import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Box,
  Button,
  createMuiTheme,
  FormControl,
  Grid,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import draftToHtml from "draftjs-to-html";
import { Info } from "@material-ui/icons";
import {
  addUpdateEventByEventUser,
  updateEventByEventUser,
  currentEventStatus,
  editEvenntByEventUser,
  updateDescriptor,
} from "../../../../Actions/eventActions";
import converter from "../../../../Helper/convertFile";
import DateFnsUtils from "@date-io/date-fns";
import ContentGrid from "../../../../Helper/gridWrapper/gridWrapper";
import {
  EditorState,
  convertToRaw,
  convertFromHTML,
  ContentState,
  insertNewUnstyledBlock,
  RichUtils,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import NativeSelect from "@material-ui/core/NativeSelect";
import EventHeader from "./eventHeader";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import load from "load-script";
import moment from "moment-timezone";
import DateAndTime from "../Tickets/dateAndTime";
import "./editor.css";
import tz from "tz-lookup";
import Resizer from "react-image-file-resizer";
import ModernDatepicker from "react-modern-datepicker";
import DatePicker from "react-modern-calendar-datepicker";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import axios from "axios";
import { history } from "../../../../store";
import { axiosE } from "../../../../Service/service";
import ImageCropper from "./ImageCropper";
import Loader from "../../../../Helper/loader/loader";
import { default as momentTz } from "moment-timezone";
import CreateEventErrorMessage from "../createEventErrorMessage";
import pica from "pica";
import ClearIcon from "@material-ui/icons/Clear";
import { ErrorMessages, eventApis, Events, Text } from "Constants";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import htmlToDraft from "html-to-draftjs";
import { ws } from "App";
import store from "store";
import storeFolder from "../../../../store";
import Checkbox from "@mui/material/Checkbox";
import {red} from "@mui/material/colors";
import Linkify from "react-linkify";

const styles = {
  eventDetailsAboutGrid: {
    "@media (max-width: 480px)": {
      padding: "0px",
    },
  },
  eventDetailsAboutMainWrapper: {
    padding: "40px",
    height: "90vh",
    overflow: "auto",
    marginTop: "0px -12px 0px -12px",
    background: "white",

    "@media (max-width: 445px)": {
      padding: "10px",
    },
  },
  eventDetailsAboutWrapper: {
    display: "flex",
    justifyContent: "center",

    "@media (max-width: 445px)": {
      padding: "10px",
    },

    "@media screen and (max-device-width:768px)": {
      paddingBottom: "50px",
    },
  },

  eventDetailsAboutFormWrapper: {
    width: "100%",
    margin: "80px 240px 0px 10px",
    // "@media only  screen and (max-width:450px)": {
    //   margin: "80px 10px 0px 0px",
    // },
    "@media only screen and (max-width: 980px)": {
      margin: "80px 100px 0px 20px",
    },

    "@media only  screen and (max-width:725px)": {
      margin: "80px 0px 0px 20px",
    },
  },

  eventDetailsAboutVerticalLineWithCirclesWrapper: {
    margin: "83px 0px 0px 0px",
    "@media screen and (max-device-width:450px)": {
      display: "none",
    },
  },

  eventDetailsAboutCircleOnVerticalLine: {
    backgroundColor: "#a338a4",
    height: "15px",
    width: "15px",
    margin: "0px 0px 112px -9px",
    borderRadius: "50%",
    "@media screen and (max-device-width:450px)": {
      display: "none",
    },
  },

  eventDetailsAboutInputLabel: {
    fontSize: "16px",
    fontWeight: "bold",
  },

  eventDetailsAboutLongInputField: {
    border: "1px solid #ced4da",
    borderRadius: "5px",
    fontSize: "16px",
    padding: "10px",
    margin: "15px 0px 30px 0px",
    width: "auto",
  },

  eventDetailsAboutInputText: {
    fontSize: "16px",
  },

  eventDetailsAboutNameLocationVenueGridWrapper: {
    margin: "2px 0px 0px 0px",
    display: "grid",
  },

  eventDetailsAboutStartEndDateGridWrapper: {
    margin: "0px 0px 0px 0px",
  },

  eventDetailsAboutStartTimeInputLabel: {
    margin: "0%",
    fontSize: "16px",
    fontWeight: "bold",
    "@media screen and (max-device-width:450px)": {},
  },

  eventDetailsAboutEndTimeInputLabel: {
    margin: "0px 0px 0px 0px",
    fontSize: "16px",
    fontWeight: "bold",
    "@media screen and (max-device-width:450px)": {
      margin: "0px",
    },
  },

  eventDetailsAboutLowerGridWrapper: {
    display: "grid",
    marginTop: "25px",
  },

  eventDetailsAboutUploadMap: {
    borderRadius: "5px",
    fontFamily:
        "HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif",
    fontSize: "14px",
    padding: "10px 25px 10px 25px",
    textTransform: "none",
    margin: "0px 0px 54px 0px",
    width: "150px",
    "@media screen and (max-device-width:450px)": {
      margin: "0px 0px 30px 0px",
    },
  },

  eventDetailsAboutSeatingChartUpload: {
    borderRadius: "5px",
    fontFamily:
        "HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif",
    fontSize: "14px",
    padding: "10px 25px 10px 25px",
    textTransform: "none",
    margin: "0px 0px 54px 0px",
    width: "210px",
    "@media screen and (max-device-width:450px)": {
      margin: "0px 0px 30px 0px",
    },
  },

  eventDetailsAboutEventTypeDropdown: {
    width: "50%",
    "@media screen and (max-device-width:1024px)": {
      width: "100%",
    },
    margin: "10px 0px 35px 0px",
  },

  eventDetailsAboutTimeInputField: {
    border: "1px solid #ced4da",
    borderRadius: "5px",
    width: "auto",
    margin: "15px 0px 28px 0px",
    padding: "10px",
    fontSize: "16px",
  },

  eventDetailsAboutDateTimePickerFont: {
    fontSize: "16px",
  },

  eventDetailsAboutLargeInputForm: {
    border: "1px solid #ced4da",
    borderRadius: "5px",
    fontSize: "16px",
    padding: "10px",
    margin: "0px 0px 20px 0px",
    width: "600px",
  },

  eventDetailsAboutButtonWrapper: {
    margin: "2% 0% 0% 0%",
    textAlign: "end",
  },

  eventDetailsAboutMakeYourEventLiveButton: {
    backgroundColor: "#a338a4",
    color: "white",
    borderRadius: "20px",
    fontFamily:
        "HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif",
    fontSize: "15px",
    padding: "10px 25px 10px 25px",
    margin: "0px 0px 40px 0px",
    textTransform: "none",
    zIndex: 4,
    "@media (max-width: 768px)": {
      margin: 0,
      width: "100%",
      borderRadius: 0,
      position: "absolute",
      bottom: 0,
      right: 0,
    },
    "&:hover": {
      color: "black",
    },
    "&:disabled": {
      background: "lightgray !important",
    },
  },

  eventDetailsAboutHTMLEditorContainer: {
    height: "300px",
    marginBottom: "50px",
    border: "1px solid lightgray",
    padding: "10px",

    "@media  screen and (max-device-width:450px)": {
      margin: "0px 0px 30px 0px",
    },
  },

  nativeSelect: {
    fontSize: "14px",
    padding: "10px",
    border: "1px solid lightgray",
  },

  suggestionActiveItem: {
    padding: "3px",
    backgroundColor: " #f1f1f1",
    cursor: "pointer",
    fontSize: " 14px",
    color: "black",
  },

  suggestionItem: {
    padding: "3px",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    color: "black",
  },
  lineHeightVerticalLineCalculator: {
    float: "left",
    borderLeft: "2px solid lightgray",
    margin: "83px 0px 0px 0px",
    "@media screen and (max-device-width:450px)": {
      display: "none",
    },

    "@media screen and (max-device-width:768px)": {
      margin: "83px 0px 0px 20px",
    },
  },
  eventImageCropperModal: {
    textAlign: "center",

    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    // borderRadius: "10px",
    padding: "10px",
    backgroundColor: "white",
    width: "100vw",
    height: "100vh",
  },
  eventDetailsAboutInputHelperText: {
    textAlign: "end",
    margin: 0,
    fontSize: "9px",
  },

  eventDetailsAboutCloneEventPopup: {
    gap: "15px",
    top: "50%",
    left: "50%",
    width: "auto",
    height: "240px",
    display: "flex",
    padding: "8px",
    position: "absolute",
    maxWidth: "430px",
    "width": "100%",
    transform: "translate(-50%, -50%)",
    aligniItems: "center",
    borderRadius: "10px",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "white",
    border: "none",
    outline: "none",
  }
};

const CreateEventDetailsAboutToolTip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: "16px",
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export class EventDetailsAbout extends Component {
  constructor(props) {
    const todayDateAndTime = moment(new Date());
    super(props);
    this.state = {
      eventTitle: "",
      eventLocation: "",
      eventAddress: "",
      eventVenue: "",
      eventStartDate: todayDateAndTime,
      eventEndDate: todayDateAndTime,
      eventStartTime: todayDateAndTime,
      eventEndTime: todayDateAndTime,
      eventMap: "",
      eventSeatingChartImage: "",
      eventImages: [],
      pendingImageFiles: [],
      eventDescription: "",
      eventParking: "",
      dropdownItem: "1",
      saveClickedForErrorMessages: false,
      editorState: EditorState.createEmpty(),
      editorState2: EditorState.createEmpty(),
      virtualEventDescription: EditorState.createEmpty(),
      editorHtml1: "",
      editorHtml2: "",
      virtualEventDescriptionHtml: "",
      loadAutocomplete: false,
      locationSuggestionExpanded: false,
      timeStartDisable: { hour: "", min: "", sec: "" },
      timeEndDisable: { hour: "", min: "", sec: "" },
      categories: [],
      eventAboutUpdate: false,
      submitButtonDisabled: false,
      eventImageCropperModal: false,
      eventImageToCrop: "",
      loader: false,
      error: { show: false, message: "" },
      addressError: false,
      eventPDF: "",
      clonealert: false,
      isValidEndDateTime: false,
      isVirtual: false, // New state for toggling virtual fields
      status: "",
      hideEndDateTime: false,
      draggedImageIndex: null,
      hoveredImageIndex: null,
    };
  }

  toggleHideEndDateTime = () => {
    this.setState((prevState) => ({hideEndDateTime: !prevState.hideEndDateTime}));
  };

  htmlToEditorState(prop) {
    const blocksFromHTML = htmlToDraft(prop);
    const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
    );
    const newState = this.customContentStateConverter(state);
    return EditorState.createWithContent(newState);
  }
  customContentStateConverter = (contentState) => {
    // changes block type of images to 'atomic'
    const newBlockMap = contentState.getBlockMap().map((block) => {
      const entityKey = block.getEntityAt(0);
      if (entityKey !== null) {
        const entityBlock = contentState.getEntity(entityKey);
        const entityType = entityBlock.getType();
        switch (entityType) {
          case "IMAGE": {
            const newBlock = block.merge({
              type: "atomic",
              text: "img",
            });
            return newBlock;
          }
          default:
            return block;
        }
      }
      return block;
    });
    const newContentState = contentState.set("blockMap", newBlockMap);
    return newContentState;
  };

  deleteEventMap = () => {
    const { eventId } = this.props;
    if (eventId) {
      axiosE.post(eventApis.deleteEventMap, { EventId: eventId });
    }
  };

  deleteSeatingChart = () => {
    const { eventId } = this.props;
    if (eventId) {
      axiosE.post(eventApis.deleteSeatingChart, { EventId: eventId });
    }
  };

  timeUTCtoLocal = (date, timezone) => {
    var local = momentTz
        .tz(moment.utc(date), "MM/DD/YYYY hh:mm:ss a", timezone)
        .format("MM/DD/YYYY hh:mm:ss a");
    return moment(local, "MM/DD/YYYY hh:mm:ss a");
  };

  GetEventFeeData = (eventId) => {
    return axiosE
        .get(`GetEventFeeData/${eventId}`)
        .then(({ data }) => {
          localStorage.setItem(
              "UBMeFee",
              JSON.stringify(Number(data.results.UBMeFee))
          );
          localStorage.setItem(
              "additionalFee",
              JSON.stringify(Number(data.results.UbmeAdditionalCharge))
          );
          localStorage.setItem(
              "CardProcessingFee",
              JSON.stringify(Number(data.results.CardProcessingFee))
          );
          localStorage.setItem(
              "CardProcessingAdditionalFee",
              JSON.stringify(Number(data.results.CardProcessingAdditionalCharge))
          );
          localStorage.setItem(
              "CurrencySymbol",
              data.results.CurrencySymbol
          );
          return data;
        })
        .catch(() => {});
  };

  toggleVirtual = () => {
    this.setState((prevState) => ({isVirtual: !prevState.isVirtual}));
  };

  componentDidMount() {
    this.loaderState(true);
    const state = store.getState();
    const eventID = state.eventUserEvents.eventId;
    let storeData = storeFolder.getState();
    const localState = localStorage.getItem("isItCreateOrEditEvent");
    const localEventId = localStorage.getItem("CurrentEventId");

    setTimeout(() => {
      if(storeData.messageReducer?.connection){
        localEventId && ws?.json({
          eventId: JSON.parse(localEventId),
          userId: storeData.loginResponse.results.ProfileDetail.UserId,
          type: "eventUserCheckedIn"
        })};
    }, 2000);

    if (
        localState === null ||
        localState === undefined ||
        localState === "" ||
        localState === "undefined"
    ) {
      localStorage.setItem("isItCreateOrEditEvent", "Edit");
      // window.location.reload();
    }
    const { eventAbout } = this.props;
    axiosE
        .get(eventApis.getAllEventCategories)
        .then((cat) => {
          this.setState({ categories: cat.data.results.Categories });
        })
        .catch((err) => {
          this.setState({ error: { show: true, message: err.message } });
        });
    /*.finally(() => {
        this.loaderState(false);
      });*/

    // const { eventId } = this.props;
    var eventId = JSON.parse(localStorage.getItem("CurrentEventId"));
    if (!eventId) {
      eventId = this.props.eventId;
    }

    if (eventId) {
      // const { eventId } = this.props;
      // localStorage.setItem("CurrentEventId", JSON.stringify(eventId));
      // const { eventId } = this.props;
      const userId = localStorage.getItem("UserId");

      this.GetEventFeeData(eventId)

      this.setState({
        eventAboutUpdate: true,
      });
      axiosE
          .get(`${eventApis.GetEventMasterById}${eventId}/${userId}/Admin`)
          .then(({ data }) => {
            const isCloneEvent = localStorage.getItem("isCloneEvent");
            if (isCloneEvent === "true" && data.results.Status !== "Published") {
              this.setState({ clonealert: true });
            }
            const { results } = data;
            this.props.editEvenntByEventUser(results);
            localStorage.setItem(
                "CurrentTimeZone",
                JSON.stringify(results?.TimeZone)
            );
            // localStorage.setItem(
            //   "PaymentDescriptor",
            //   results.PaymentDescriptor
            // );
            this.props.updateDescriptor({
              EventId: eventId,
              PaymentDescriptor: results.PaymentDescriptor,
            });
            if (Boolean(results.EventId)) {
              this.setState({
                eventTitle: results.Title,
                eventLocation: results.Add1,
                eventAddress: {
                  name: results.Add1,
                  addr: results.Add2,
                  lat: results.Latitude,
                  lng: results.Longitude,
                  city: results.City,
                  country: results.Country,
                  state: results.Region,
                  timezone: results.TimeZone,
                  postalCode: results.PostalCode,
                },
                eventVenue: results.VenueName,
                eventStartDate: this.timeUTCtoLocal(
                    isCloneEvent === "true"
                        ? moment(new Date())
                        : results.StartDateTime,
                    results.TimeZone
                ),
                eventEndDate: this.timeUTCtoLocal(
                    isCloneEvent === "true"
                        ? moment(new Date())
                        : results.EndDateTime,
                    results.TimeZone
                ),
                eventStartTime: this.timeUTCtoLocal(
                    isCloneEvent === "true"
                        ? moment(new Date())
                        : results.StartDateTime,
                    results.TimeZone
                ),
                eventEndTime: this.timeUTCtoLocal(
                    isCloneEvent === "true"
                        ? moment(new Date())
                        : results.EndDateTime,
                    results.TimeZone
                ),
                eventMap: this.validatePDF(results.EventMap),
                eventSeatingChartImage: this.validateUrl(results.SeatingChartImage),
                // eventImages: [{
                //   large: results.ImageLarge,
                //   medium: results.ImageMedium,
                //   small: results.ImageSmall,
                // }],
                eventImages: (results.Images && results.Images.length > 0)
                    ? results.Images.map(img => ({
                      large:  img.ImageLarge  || "",
                      medium: img.ImageMedium || "",
                      small:  img.ImageSmall  || "",
                    }))
                    : results.ImageSmall
                        ? [{ large: results.ImageLarge, medium: results.ImageMedium, small: results.ImageSmall }]
                        : [],
                eventDescription: results.Description,
                eventParking: results.Parking,
                dropdownItem: results.EventType,
                saveClickedForErrorMessages: false,
                editorState: this.htmlToEditorState(results.Description),
                editorState2: this.htmlToEditorState(results.Parking),
                virtualEventDescription: this.htmlToEditorState(results.VirtualEventDetails),
                editorHtml1: results.Description,
                editorHtml2: results.Parking,
                virtualEventDescriptionHtml: results.VirtualEventDetails,
                loadAutocomplete: true,
                locationSuggestionExpanded: false,
                isVirtual: results.IsVirtualEvent === "True" ? true : false,
                hideEndDateTime: results.HideEndDateTime === "True" ? true : false,
                status: results.Status,
              });
            }
          })
          .catch((err) => {
            this.setState({ error: { show: true, message: err.message } });
            console.log(err);
          })
          .finally(() => this.loaderState(false));
    } else {
      this.loaderState(false);
    }
  }

  componentWillUnmount() {
    // localStorage.removeItem("CurrentEventId");
  }

  validatePDF = (url) => {
    if (url) {
      const urlParts = url.split(".");
      if (urlParts[urlParts.length - 1] === "pdf") {
        return url;
      }
    }
    return "";
  };

  validateUrl = (url) => {
    if (url) {
      const urlParts = url.split(".");
      if (urlParts[urlParts.length - 1] === "jpg" || urlParts[urlParts.length - 1] === "jpeg") {
        return url;
      }
    }
    return "";
  };

  removeEventMap = () => {
    const url = this.props.eventAbout && this.props.eventAbout.EventMap;
    if (url) {
      const urlParts = url.split(".");
      if (urlParts[urlParts.length - 1] === "pdf") {
        this.deleteEventMap();
      }
    }
    this.setState({ eventMap: "" });
  };

  removeSeatingChart = () => {
    const url = this.props.eventAbout && this.props.eventAbout.SeatingChartImage;
    if (url) {
      const urlParts = url.split(".");
      if (urlParts[urlParts.length - 1] === "jpeg") {
        this.deleteSeatingChart();
      }
    }
    this.setState({ eventSeatingChartImage: "" });
  };

  componentWillMount() {
    load(
        "https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBr9MSaEjodT_Q9bnUqUcusJ8HWmQmJRC0",
        (e, err) => {
          if (e) {
            this.setState({ error: { show: true, message: err.message } });
          } else {
            this.setState({
              loadAutocomplete: true,
            });
          }
        }
    );
  }
  onEditorStateChange = (editorState) => {
    const editorHtml = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
    );

    this.setState({
      editorState,
      editorHtml1: editorHtml,
    });
  };

  onEditorStateChange1 = (editorState2) => {
    const innerContent = convertToRaw(editorState2.getCurrentContent());
    // const editorHtml = !!innerContent.blocks[0].text
    //   ? draftToHtml(innerContent)
    //   : "";
    const editorHtml = draftToHtml(innerContent);
    this.setState({
      editorState2,
      editorHtml2: editorHtml,
    });
  };

  onVirtualEventStateChange = (virtualEventDescription) => {
    const innerContent = convertToRaw(virtualEventDescription.getCurrentContent());
    // const editorHtml = !!innerContent.blocks[0].text
    //   ? draftToHtml(innerContent)
    //   : "";
    const editorHtml = draftToHtml(innerContent);
    this.setState({
      virtualEventDescription,
      virtualEventDescriptionHtml: editorHtml,
    });
  };

  handleDropdownChange = (e) => {
    this.setState({
      dropdownItem: e.target.value,
    });
  };

  getCityStateCountry = (results) => {
    const address = results[0].formatted_address;
    let addr, city, state, country, postalCode;
    for (let i = 0; i < results[0].address_components.length; i++) {
      for (let j = 0; j < results[0].address_components[i].types.length; j++) {
        switch (results[0].address_components[i].types[j]) {
          case "street_number":
            addr = results[0].address_components[i].long_name;
            break;
          case "premise":
            addr = addr
                ? addr + " " + results[0].address_components[i].long_name
                : results[0].address_components[i].long_name;
            break;
          case "route":
            addr = addr
                ? addr + " " + results[0].address_components[i].long_name
                : results[0].address_components[i].long_name;
            break;
          case "sublocality":
            city = results[0].address_components[i].long_name;
            break;
          case "locality":
            city = results[0].address_components[i].long_name;
            break;
          case "postal_town":
            city = results[0].address_components[i].long_name;
            break;
          case "sublocality_level_1":
            city = results[0].address_components[i].long_name;
            break;
          case "administrative_area_level_1":
            state = results[0].address_components[i].long_name;
            break;
          case "country":
            country = results[0].address_components[i].long_name;
            break;
          case "postal_code":
            postalCode = results[0].address_components[i].long_name;
            break;
        }
      }
    }

    return [address, addr, country, city, state, postalCode];
  };

  handleLocationSelect = (address) => {
    let fullAddress;
    geocodeByAddress(address)
        .then((results) => {
          fullAddress = this.getCityStateCountry(results);
          return getLatLng(results[0]);
        })
        .then((latLng) => {
          this.setState({
            eventAddress: {
              name: fullAddress[0],
              addr: fullAddress[1],
              ...latLng,
              timezone: tz(latLng.lat, latLng.lng),
              country: fullAddress[2],
              city: fullAddress[3],
              state: fullAddress[4],
              postalCode: fullAddress[5],
            },
            eventLocation: address,
          });
        });
  };
  inputChange = (textField, e) => {
    if (textField === "eventLocation" && !this.state["eventAddress"]) {
      this.setState({ addressError: true });
    }
    this.setState({
      [textField]: textField == "eventLocation" ? e : e.target.value,
    });
  };
  ChangeStartDate = (date) => {
    const completeDate = `${date.month}-${date.day}-${date.year}`;
    this.setState({
      eventStartDate: moment(completeDate, "MM/DD/YYYY"),
      // eventEndDate: moment(completeDate, "MM/DD/YYYY"),
    });
  };
  ChangeEndDate = (date) => {
    const completeDate = `${date.month}-${date.day}-${date.year}`;
    this.setState({
      eventEndDate: moment(completeDate, "MM/DD/YYYY"),
    });
  };
  ChangeStartTime = (date) => {
    if (date === null || date === "invalid date") {
      this.setState({
        eventStartTime: moment(),
        eventEndTime: moment(),
      });
    } else {
      this.setState({
        eventEndTime: moment(date),
        eventStartTime: moment(date),
      });
    }
  };
  ChangeEndTime = (date) => {
    if (date === null || date === "invalid date") {
      this.setState({
        eventEndTime: moment(),
      });
    } else {
      this.setState({
        eventEndTime: moment(date),
      });
    }
  };

  uploadPicture = async (e, type) => {
    e.stopPropagation();
    const files = Array.from(e.target.files);

    if (!files.length) {
      this.setState({ error: { show: true, message: ErrorMessages.imageNotFound } });
      return;
    }

    const currentCount = this.state.eventImages.length;
    const remaining = 5 - currentCount;

    if (remaining <= 0) {
      this.setState({ error: { show: true, message: "Maximum 5 images allowed." } });
      return;
    }

    const allowedFiles = files.slice(0, remaining);

    // Validate sizes first
    const validFiles = allowedFiles.filter(file => {
      if (file.size > 5000000) {
        this.setState({ error: { show: true, message: ErrorMessages.imageSize } });
        return false;
      }
      return true;
    });

    if (!validFiles.length) return;

    // Store all pending files, open cropper for the first one
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        eventImageToCrop: reader.result,
        eventImageCropperModal: true,
        pendingImageFiles: validFiles.slice(1), // rest wait in queue
      });
    };
    reader.readAsDataURL(validFiles[0]);
  };

  // Call this when cropper finishes one image
  onCropDone = (croppedImage) => {
    this.setState(
        (prev) => ({
          eventImages: [
            ...prev.eventImages,
            {
              large: null,
              medium: null,
              small: croppedImage,  // or however your cropper returns the result
              preview: croppedImage,
              file: null,
            },
          ],
          eventImageCropperModal: false,
        }),
        () => {
          // If more files are waiting, open cropper for next one
          const { pendingImageFiles = [] } = this.state;
          if (pendingImageFiles.length > 0) {
            const [nextFile, ...rest] = pendingImageFiles;
            const reader = new FileReader();
            reader.onload = () => {
              this.setState({
                eventImageToCrop: reader.result,
                eventImageCropperModal: true,
                pendingImageFiles: rest,
              });
            };
            reader.readAsDataURL(nextFile);
          }
        }
    );
  };

  swapImages = (dropIndex) => {
    const { draggedImageIndex, eventImages } = this.state;

    if (draggedImageIndex === null || draggedImageIndex === dropIndex) return;

    const updatedImages = [...eventImages];
    // Swap the two images
    [updatedImages[draggedImageIndex], updatedImages[dropIndex]] =
        [updatedImages[dropIndex], updatedImages[draggedImageIndex]];

    this.setState({
      eventImages: updatedImages,
      draggedImageIndex: null,
    });
  };

  removeImage = (index) => {
    this.setState((prev) => ({
      eventImages: prev.eventImages.filter((_, i) => i !== index),
    }));
  };

  uploadSeatingChartPicture = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { seatingChart } = this.state;

    const file = e.target.files[0];
    if (file !== undefined) {
      if (file.size <= 5000000) {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = async () => {
            const maxWidth = 1920; // Maximum width for the resized image
            const maxHeight = 960; // Maximum height for the resized image
            let width = img.width;
            let height = img.height;

            // Calculate new width and height to maintain aspect ratio
            if (width > height) {
              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
              }
            }

            // Create a canvas element to draw the resized image
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            // Convert the canvas content to base64 encoded data
            const resizedEncodedData = canvas.toDataURL('image/jpeg'); // Change format if needed

            this.setState({
              eventSeatingChartImage:  resizedEncodedData,
            });
          };
        };
        reader.readAsDataURL(file);
      } else {
        this.setState({
          error: { show: true, message: ErrorMessages.imageSize },
        });
      }
    } else {
      this.setState({
        error: { show: true, message: ErrorMessages.imageNotFound },
      });
    }
  };

  setMultipleResizedImages = async (img) => {
    // Close cropper
    this.setState((prev) => {
      const newIndex = prev.eventImages.length;
      const updatedImages = [
        ...prev.eventImages,
        { large: null, medium: null, small: null }, // new empty slot
      ];
      return {
        eventImageCropperModal: false,
        eventImages: updatedImages,
        _lastAddedImageIndex: newIndex, // track which index we're filling
      };
    }, () => {
      const imageIndex = this.state._lastAddedImageIndex;

      [
        { width: 1920, height: 960, title: "large" },
        { width: 512, height: 256, title: "medium" },
        { width: 240, height: 120, title: "small" },
      ].forEach((size) => {
        this.increaseSize(img, size, imageIndex);
      });

      // Process next pending file if any
      const { pendingImageFiles = [] } = this.state;
      if (pendingImageFiles.length > 0) {
        const [nextFile, ...rest] = pendingImageFiles;
        const reader = new FileReader();
        reader.onload = () => {
          this.setState({
            eventImageToCrop: reader.result,
            eventImageCropperModal: true,
            pendingImageFiles: rest,
          });
        };
        reader.readAsDataURL(nextFile);
      }
    });
  };

  setCroppedImage = (img) => {
    this.setState({
      eventCroppedImage: img,
    });
  };

  handleCropImageModal = (show) => {
    this.setState({
      eventImageCropperModal: show,
    });
  };

  imageLoader = (file, spec) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "Anonymous";
      image.onload = (e) => {
        resolve({
          image,
          width: spec.width,
          height: spec.height,
        });
      };

      const reader = new FileReader();
      reader.onload = () => {
        image.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  };

  calculate = (t) => {
    return (
        Math.round((performance.now() - t + Number.EPSILON) * 100) / 100 + "ms"
    );
  };
  format = ({ size }) => {
    if (size === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  increaseSize = (file, spec, imageIndex) => {
    const resizer = new pica();

    if (file) {
      this.imageLoader(file, spec).then(({ image, width, height }) => {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        resizer
            .resize(image, canvas)
            .then((result) => resizer.toBlob(result, "image/png"))
            .then((blob) => {
              if (file) {
                file.src = URL.createObjectURL(blob);
              }

              const reader = new FileReader();
              reader.onload = () => {
                this.setState((prev) => {
                  const updatedImages = [...prev.eventImages];
                  updatedImages[imageIndex] = {
                    ...updatedImages[imageIndex],
                    [spec.title]: reader.result,
                  };
                  return { eventImages: updatedImages };
                });
              };
              reader.readAsDataURL(blob);
              canvas.remove();
              image.remove();
            }).catch(err => console.log(err));
      }).catch(err => console.log(err));
    }
  };

  checkDimensions = (e) => {
    const fileUpload = e.target;

    // Remove Previous Images from State
    this.setState({
      eventImages: [],
    });

    var reader = new FileReader();
    reader.readAsDataURL(fileUpload.files[0]);

    const ResizeImages = (fileUpload) =>
        this.setMultipleResizedImages(fileUpload);

    //Read the contents of Image File.
    reader.onload = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;

      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        if (height >= 793 && width >= 1920) {
          ResizeImages(fileUpload);
        } else {
        }
      };
    };
  };

  createEventDetailsAboutErrorMessageLabelStyles = (textField) => {
    const { CreateEventErrorMessage } = this.state;
    return {
      color: "red",
      fontSize: "16px",
      fontWeight: "100",
      margin: "0px 0px 0px 10px",
      display:
          CreateEventErrorMessage && this.state[textField] === ""
              ? "initial"
              : "none",
    };
  };

  addressErrorMessage = () => {
    const { addressError } = this.state;
    return {
      color: "red",
      fontSize: "16px",
      fontWeight: "100",
      margin: "0px 0px 0px 10px",
      display:
          addressError && this.state["eventAddress"] === "" ? "initial" : "none",
    };
  };

  createEventDetailsAboutEventCreatedSuccessMessageStyles = () => {
    return {
      color: "green",
      margin: "50px 0px 50px 0px",
      textAlign: "center",
      display: "none",
    };
  };

  fileToBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(null, reader.result);
    };
    reader.onerror = function (error) {
      cb(error, null);
    };
  };

  uploadPDF = ({ target }) => {
    if (target.files < 1 || !target.validity.valid) {
      return;
    }
    this.setState({
      eventPDF: target.files[0],
    });
    this.fileToBase64(target.files[0], (err, result) => {
      if (result) {
        this.setState({
          eventMap: result,
        });
      }
    });
  };

  textFieldSuggestionInputWithTitle = (title) => {
    const { classes } = this.props;
    const formTitleMap = {
      "Event Title": "eventTitle",
      [title]: "eventLocation",
      "Venue Name": "eventVenue",
    };
    const searchOptions = {
      types: ["(cities)"],
    };

    const { About } = Events;

    return (
        <FormControl>
        <span className={classes.eventDetailsAboutInputLabel}>
          {title !== "Address" && this.titleWithToolTip(title, true)}
          <p
              style={this.createEventDetailsAboutErrorMessageLabelStyles(
                  "eventLocation"
              )}
          >{`Please Select a Location`}</p>
        </span>
          <span className={classes.eventDetailsAboutInputLabel}>
          {title === "Address" &&
              this.titleWithToolTip(
                  title,
                  About.addressExtraText,
                  true
              )}
            <p style={this.addressErrorMessage()}>{`Please Select a Location`}</p>
        </span>

          {this.state.loadAutocomplete && (
              <PlacesAutocomplete
                  value={this.state.eventLocation}
                  onChange={(e) => this.inputChange(formTitleMap[title], e)}
                  onSelect={(address) => this.handleLocationSelect(address)}
                  // searchOptions={searchOptions}
              >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                    <>
                      <TextField
                          {...getInputProps({
                            fullWidth: true,
                            required: true,
                            className: classes.eventDetailsAboutLongInputField,
                            placeholder: title,
                            margin: "normal",
                            InputProps: {
                              disableUnderline: true,
                              className: classes.eventDetailsAboutInputText,
                            },
                          })}
                      />
                      <div
                          style={{
                            margin: "-35px 0px 10px 0px",
                            // overflow: "hidden",
                            overflowY: "auto",
                            height: "50px",
                            backgroundColor: "white",
                            border:
                                suggestions.length > 0 ? "1px solid #ced4da" : "0px",
                            borderRadius: "5px",
                          }}
                      >
                        {suggestions.map((suggestion) => {
                          const className = suggestion.active
                              ? classes.suggestionActiveItem
                              : classes.suggestionItem;

                          return (
                              <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                  })}
                              >
                                <span>{suggestion.description}</span>
                              </div>
                          );
                        })}
                      </div>
                    </>
                )}
              </PlacesAutocomplete>
          )}
        </FormControl>
    );
  };

  // config = {
  //   "451": {
  //     small: {
  //       withVirtualText: {
  //         withMap: {
  //           withSeatingChart: "2160px",
  //           withoutSeatingChart: "2040px",
  //         },
  //         withoutMap: {
  //           withSeatingChart: "2110px",
  //           withoutSeatingChart: "1990px",
  //         },
  //       },
  //       withoutVirtualText: {
  //         withMap: {
  //           withSeatingChart: "2120px",
  //           withoutSeatingChart: "2000px",
  //         },
  //         withoutMap: {
  //           withSeatingChart: "2070px",
  //           withoutSeatingChart: "1950px",
  //         },
  //       },
  //     },
  //     withoutImage: {
  //       withVirtualText: {
  //         withMap: {
  //           withSeatingChart: "2040px",
  //           withoutSeatingChart: "1920px",
  //         },
  //         withoutMap: {
  //           withSeatingChart: "1990px",
  //           withoutSeatingChart: "1870px",
  //         },
  //       },
  //     },
  //     circleMargins: [
  //       "124px", "180px", "130px", "110px", "130px", "248px", "110px", "130px", "104px", "510px", "0px"
  //     ]
  //   },
  //   virtual: {
  //     "451": {
  //       small: {
  //         withVirtualText: {
  //           withMap: {
  //             withSeatingChart: "2910px",
  //             withoutSeatingChart: "2790px",
  //           },
  //           withoutMap: {
  //             withSeatingChart: "2860px",
  //             withoutSeatingChart: "2740px",
  //           },
  //         },
  //         withoutVirtualText: {
  //           withMap: {
  //             withSeatingChart: "2850px",
  //             withoutSeatingChart: "2730px",
  //           },
  //           withoutMap: {
  //             withSeatingChart: "2800px",
  //             withoutSeatingChart: "2680px",
  //           },
  //         },
  //       },
  //       withoutImage: {
  //         withVirtualText: {
  //           withMap: {
  //             withSeatingChart: "2780px",
  //             withoutSeatingChart: "2660px",
  //           },
  //           withoutMap: {
  //             withSeatingChart: "2730px",
  //             withoutSeatingChart: "2610px",
  //           },
  //         },
  //       },
  //       circleMargins: [
  //         "124px", "180px", "120px", "720px", "110px", "130px", "110px", "130px", "130px", "104px", "510px", "0px"
  //       ]
  //     }
  //   }
  //     // Repeat for other widths like "1455", "default", and virtual configurations...
  // };

  getImageBucket = (count) => {
    if (count <= 0) return "0";
    if (count === 1) return "1";
    if (count === 2) return "2";
    if (count === 3) return "3";
    if (count === 4) return "4";
    return "5"; // 5+
  };

  getBucketConfig = (source, count) => {
    for (let i = count; i >= 0; i--) {
      if (source?.[String(i)]) {
        return source[String(i)];
      }
    }
    return null;
  };

  // Helper function to generate the seating chart options
  generateSeatingChartConfig = (withSeatingChart, withoutSeatingChart) => ({
    withSeatingChart,
    withoutSeatingChart,
  });

// Helper function to generate the main structure for with/without text and map
  generateMapConfig = (withSeatingChart, withoutSeatingChart) => ({
    withMap: this.generateSeatingChartConfig(withSeatingChart.withMap, withoutSeatingChart.withMap),
    withoutMap: this.generateSeatingChartConfig(withSeatingChart.withoutMap, withoutSeatingChart.withoutMap),
  });

  config = {
    "451": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2105px", withoutMap: "2055px" },
              { withMap: "1950px", withoutMap: "1900px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2065px", withoutMap: "2015px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
        "2": {
          //DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2195px", withoutMap: "2145px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2155px", withoutMap: "2105px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        },
        "3": {
          //DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2195px", withoutMap: "2145px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2155px", withoutMap: "2105px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2285px", withoutMap: "2235px" },
              { withMap: "2130px", withoutMap: "2080px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2245px", withoutMap: "2195px" },
              { withMap: "2090px", withoutMap: "2040px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2285px", withoutMap: "2235px" },
              { withMap: "2130px", withoutMap: "2080px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2245px", withoutMap: "2195px" },
              { withMap: "2090px", withoutMap: "2040px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2105px", withoutMap: "2055px" },
              { withMap: "1950px", withoutMap: "1905px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2065px", withoutMap: "2015px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px",
        "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "526": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2070px", withoutMap: "2020px" },
              { withMap: "1950px", withoutMap: "1900px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2030px", withoutMap: "1980px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2160px", withoutMap: "2110px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2120px", withoutMap: "2070px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2160px", withoutMap: "2110px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2120px", withoutMap: "2070px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2250px", withoutMap: "2200px" },
              { withMap: "2130px", withoutMap: "2080px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2210px", withoutMap: "2160px" },
              { withMap: "2090px", withoutMap: "2040px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2250px", withoutMap: "2200px" },
              { withMap: "2130px", withoutMap: "2080px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2210px", withoutMap: "2160px" },
              { withMap: "2090px", withoutMap: "2040px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2070px", withoutMap: "2020px" },
              { withMap: "1950px", withoutMap: "1905px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2030px", withoutMap: "1980px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "566": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2070px", withoutMap: "2020px" },
              { withMap: "1950px", withoutMap: "1900px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2030px", withoutMap: "1980px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2070px", withoutMap: "2020px" },
              { withMap: "1950px", withoutMap: "1900px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2030px", withoutMap: "1980px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2160px", withoutMap: "2110px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2120px", withoutMap: "2070px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2160px", withoutMap: "2110px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2120px", withoutMap: "2070px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2160px", withoutMap: "2110px" },
              { withMap: "2040px", withoutMap: "1990px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2120px", withoutMap: "2070px" },
              { withMap: "2000px", withoutMap: "1950px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2070px", withoutMap: "2020px" },
              { withMap: "1950px", withoutMap: "1905px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2030px", withoutMap: "1980px" },
              { withMap: "1910px", withoutMap: "1860px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "622": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),

          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "675": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "696": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "726": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "769": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "779": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2000px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2135px", withoutMap: "2085px" },
              { withMap: "2015px", withoutMap: "1965px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2095px", withoutMap: "2045px" },
              { withMap: "1975px", withoutMap: "1925px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "1152": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2000px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "1260": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "1280": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "1372": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2045px", withoutMap: "1995px" },
              { withMap: "1925px", withoutMap: "1875px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2005px", withoutMap: "1955px" },
              { withMap: "1885px", withoutMap: "1835px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "1480": {
      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    "1576": {
      // small: {
      //   withVirtualText: this.generateMapConfig(
      //       { withMap: "2155px", withoutMap: "2105px" },
      //       { withMap: "2035px", withoutMap: "1985px" }
      //   ),
      //   withoutVirtualText: this.generateMapConfig(
      //       { withMap: "2115px", withoutMap: "2065px" },
      //       { withMap: "1995px", withoutMap: "1945px" }
      //   ),
      // },
      // withoutImage: {
      //   withVirtualText: this.generateMapConfig(
      //       { withMap: "2035px", withoutMap: "1985px" },
      //       { withMap: "1915px", withoutMap: "1865px" }
      //   ),
      // },

      small: {
        "1": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "2": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "3": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "4": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
        "5": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        }
      },

      withoutImage: {
        "0": {
          // DONE
          withVirtualText: this.generateMapConfig(
              { withMap: "2025px", withoutMap: "1975px" },
              { withMap: "1905px", withoutMap: "1855px" }
          ),
          // DONE
          withoutVirtualText: this.generateMapConfig(
              { withMap: "1985px", withoutMap: "1935px" },
              { withMap: "1865px", withoutMap: "1815px" }
          ),
        },
      },

      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    default: {
      small: {
        withVirtualText: this.generateMapConfig(
            { withMap: "2195px", withoutMap: "2145px" },
            { withMap: "2075px", withoutMap: "2025px" }
        ),
        withoutVirtualText: this.generateMapConfig(
            { withMap: "2155px", withoutMap: "2105px" },
            { withMap: "2035px", withoutMap: "1985px" }
        ),
      },
      withoutImage: {
        withVirtualText: this.generateMapConfig(
            { withMap: "2075px", withoutMap: "2025px" },
            { withMap: "1955px", withoutMap: "1905px" }
        ),
      },
      circleMargins: [
        "124px", "180px", "130px", "110px", "140px", "248px", "110px", "130px", "104px", "510px", "0px"
      ],
    },
    virtual: {
      "451": {
        small: {
          "1": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "2845px", withoutMap: "2800px" },
                { withMap: "2695px", withoutMap: "2645px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2790px", withoutMap: "2740px" },
                { withMap: "2635px", withoutMap: "2585px" }
            ),
          },
          "2": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "2940px", withoutMap: "2890px" },
                { withMap: "2785px", withoutMap: "2735px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2880px", withoutMap: "2830px" },
                { withMap: "2725px", withoutMap: "2675px" }
            ),
          },
          "3": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "2940px", withoutMap: "2890px" },
                { withMap: "2785px", withoutMap: "2735px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2880px", withoutMap: "2830px" },
                { withMap: "2725px", withoutMap: "2675px" }
            ),
          },
          "4": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "3030px", withoutMap: "2980px" },
                { withMap: "2875px", withoutMap: "2825px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2970px", withoutMap: "2920px" },
                { withMap: "2815px", withoutMap: "2765px" }
            ),
          },
          "5": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "3030px", withoutMap: "2980px" },
                { withMap: "2875px", withoutMap: "2825px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2970px", withoutMap: "2920px" },
                { withMap: "2815px", withoutMap: "2765px" }
            ),
          }
        },

        withoutImage: {
          "0": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "2845px", withoutMap: "2795px" },
                { withMap: "2690px", withoutMap: "2645px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2790px", withoutMap: "2740px" },
                { withMap: "2635px", withoutMap: "2585px" }
            ),
          },
        },

        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "526": {
        // small: {
        //   withVirtualText: this.generateMapConfig(
        //       { withMap: "2925px", withoutMap: "2875px" },
        //       { withMap: "2805px", withoutMap: "2755px" }
        //   ),
        //   withoutVirtualText: this.generateMapConfig(
        //       { withMap: "2865px", withoutMap: "2815px" },
        //       { withMap: "2745px", withoutMap: "2695px" }
        //   ),
        // },
        // withoutImage: {
        //   withVirtualText: this.generateMapConfig(
        //       { withMap: "2805px", withoutMap: "2755px" },
        //       { withMap: "2685px", withoutMap: "2635px" }
        //   ),
        // },

        small: {
          "1": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "2795px", withoutMap: "2745px" },
                { withMap: "2670px", withoutMap: "2625px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2735px", withoutMap: "2685px" },
                { withMap: "2615px", withoutMap: "2565px" }
            ),
          },
          "2": {

            withVirtualText: this.generateMapConfig(
                { withMap: "2940px", withoutMap: "2890px" },
                { withMap: "2785px", withoutMap: "2735px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2825px", withoutMap: "2775px" },
                { withMap: "2705px", withoutMap: "2655px" }
            ),
          },
          "3": {

            withVirtualText: this.generateMapConfig(
                { withMap: "2940px", withoutMap: "2890px" },
                { withMap: "2785px", withoutMap: "2735px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2825px", withoutMap: "2775px" },
                { withMap: "2705px", withoutMap: "2655px" }
            ),
          },
          "4": {

            withVirtualText: this.generateMapConfig(
                { withMap: "3030px", withoutMap: "2980px" },
                { withMap: "2875px", withoutMap: "2825px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2950px", withoutMap: "2900px" },
                { withMap: "2795px", withoutMap: "2745px" }
            ),
          },
          "5": {

            withVirtualText: this.generateMapConfig(
                { withMap: "3030px", withoutMap: "2980px" },
                { withMap: "2875px", withoutMap: "2825px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2950px", withoutMap: "2900px" },
                { withMap: "2795px", withoutMap: "2745px" }
            ),
          }
        },

        withoutImage: {
          "0": {
            // DONE
            withVirtualText: this.generateMapConfig(
                { withMap: "2795px", withoutMap: "2745px" },
                { withMap: "2670px", withoutMap: "2625px" }
            ),
            // DONE
            withoutVirtualText: this.generateMapConfig(
                { withMap: "2735px", withoutMap: "2685px" },
                { withMap: "2615px", withoutMap: "2565px" }
            ),
          },
        },

        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "566": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2905px", withoutMap: "2855px" },
              { withMap: "2785px", withoutMap: "2735px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2845px", withoutMap: "2795px" },
              { withMap: "2725px", withoutMap: "2675px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2785px", withoutMap: "2735px" },
              { withMap: "2665px", withoutMap: "2615px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "622": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2875px", withoutMap: "2825px" },
              { withMap: "2755px", withoutMap: "2705px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2815px", withoutMap: "2765px" },
              { withMap: "2695px", withoutMap: "2645px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2755px", withoutMap: "2705px" },
              { withMap: "2635px", withoutMap: "2585px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "675": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2835px", withoutMap: "2785px" },
              { withMap: "2715px", withoutMap: "2665px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2775px", withoutMap: "2725px" },
              { withMap: "2655px", withoutMap: "2605px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2715px", withoutMap: "2665px" },
              { withMap: "2595px", withoutMap: "2545px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "696": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2815px", withoutMap: "2765px" },
              { withMap: "2695px", withoutMap: "2645px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2775px", withoutMap: "2725px" },
              { withMap: "2655px", withoutMap: "2605px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2695px", withoutMap: "2645px" },
              { withMap: "2575px", withoutMap: "2525px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "726": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2875px", withoutMap: "2825px" },
              { withMap: "2755px", withoutMap: "2705px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2815px", withoutMap: "2765px" },
              { withMap: "2695px", withoutMap: "2645px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2720px", withoutMap: "2670px" },
              { withMap: "2600px", withoutMap: "2550px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "769": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2835px", withoutMap: "2785px" },
              { withMap: "2715px", withoutMap: "2665px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2775px", withoutMap: "2725px" },
              { withMap: "2655px", withoutMap: "2605px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2715px", withoutMap: "2665px" },
              { withMap: "2595px", withoutMap: "2545px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "779": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2815px", withoutMap: "2765px" },
              { withMap: "2695px", withoutMap: "2645px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2755px", withoutMap: "2705px" },
              { withMap: "2635px", withoutMap: "2585px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2695px", withoutMap: "2645px" },
              { withMap: "2575px", withoutMap: "2525px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "1152": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2795px", withoutMap: "2745px" },
              { withMap: "2675px", withoutMap: "2625px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2755px", withoutMap: "2705px" },
              { withMap: "2635px", withoutMap: "2585px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2675px", withoutMap: "2625px" },
              { withMap: "2555px", withoutMap: "2505px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "1260": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2775px", withoutMap: "2725px" },
              { withMap: "2655px", withoutMap: "2605px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2735px", withoutMap: "2685px" },
              { withMap: "2615px", withoutMap: "2565px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2655px", withoutMap: "2605px" },
              { withMap: "2535px", withoutMap: "2485px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "1280": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2815px", withoutMap: "2765px" },
              { withMap: "2695px", withoutMap: "2645px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2775px", withoutMap: "2725px" },
              { withMap: "2655px", withoutMap: "2605px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2695px", withoutMap: "2645px" },
              { withMap: "2575px", withoutMap: "2525px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "1372": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2795px", withoutMap: "2745px" },
              { withMap: "2675px", withoutMap: "2625px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2755px", withoutMap: "2705px" },
              { withMap: "2635px", withoutMap: "2585px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2675px", withoutMap: "2625px" },
              { withMap: "2555px", withoutMap: "2505px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "1480": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2775px", withoutMap: "2725px" },
              { withMap: "2655px", withoutMap: "2605px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2735px", withoutMap: "2685px" },
              { withMap: "2615px", withoutMap: "2565px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2655px", withoutMap: "2605px" },
              { withMap: "2535px", withoutMap: "2485px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      "1576": {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2755px", withoutMap: "2705px" },
              { withMap: "2635px", withoutMap: "2585px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2715px", withoutMap: "2665px" },
              { withMap: "2595px", withoutMap: "2545px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2635px", withoutMap: "2585px" },
              { withMap: "2515px", withoutMap: "2465px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
      default: {
        small: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2945px", withoutMap: "2895px" },
              { withMap: "2825px", withoutMap: "2775px" }
          ),
          withoutVirtualText: this.generateMapConfig(
              { withMap: "2885px", withoutMap: "2835px" },
              { withMap: "2765px", withoutMap: "2715px" }
          ),
        },
        withoutImage: {
          withVirtualText: this.generateMapConfig(
              { withMap: "2815px", withoutMap: "2765px" },
              { withMap: "2695px", withoutMap: "2655px" }
          ),
        },
        circleMargins: [
          "124px", "180px", "120px", "720px", "110px", "140px", "110px", "130px", "130px", "104px", "510px", "0px"
        ],
      },
    }
  };

  getConfig = (isVirtual, windowWidth) => {
    // Check for the virtual conditions first
    if (isVirtual) {
      if (windowWidth >= 1576) {
        return this.config.virtual["1576"];
      } else if (windowWidth >= 1480) {
        return this.config.virtual["1480"];
      } else if (windowWidth >= 1372) {
        return this.config.virtual["1372"];
      } else if (windowWidth >= 1280) {
        return this.config.virtual["1280"];
      } else if (windowWidth >= 1260) {
        return this.config.virtual["1260"];
      } else if (windowWidth >= 1152) {
        return this.config.virtual["1152"];
      } else if (windowWidth >= 779) {
        return this.config.virtual["779"];
      } else if (windowWidth >= 769) {
        return this.config.virtual["769"];
      } else if (windowWidth >= 726) {
        return this.config.virtual["726"];
      } else if (windowWidth >= 696) {
        return this.config.virtual["696"];
      } else if (windowWidth >= 675) {
        return this.config.virtual["675"];
      } else if (windowWidth >= 622) {
        return this.config.virtual["622"];
      } else if (windowWidth >= 566) {
        return this.config.virtual["566"];
      } else if (windowWidth >= 526) {
        return this.config.virtual["526"];
      } else if (windowWidth >= 451) {
        return this.config.virtual["451"];
      } else {
        return this.config.virtual.default;
      }
    } else { // Non-virtual conditions
      if (windowWidth >= 1576) {
        return this.config["1576"];
      } else if (windowWidth >= 1480) {
        return this.config["1480"];
      } else if (windowWidth >= 1372) {
        return this.config["1372"];
      } else if (windowWidth >= 1280) {
        return this.config["1280"];
      } else if (windowWidth >= 1260) {
        return this.config["1260"];
      } else if (windowWidth >= 1152) {
        return this.config["1152"];
      } else if (windowWidth >= 779) {
        return this.config["779"];
      } else if (windowWidth >= 769) {
        return this.config["769"];
      } else if (windowWidth >= 726) {
        return this.config["726"];
      } else if (windowWidth >= 696) {
        return this.config["696"];
      } else if (windowWidth >= 675) {
        return this.config["675"];
      } else if (windowWidth >= 622) {
        return this.config["622"];
      } else if (windowWidth >= 566) {
        return this.config["566"];
      } else if (windowWidth >= 526) {
        return this.config["526"];
      } else if (windowWidth >= 451) {
        return this.config["451"];
      } else {
        return this.config.default;
      }
    }
  };

  verticalLineWithCircles = () => {
    const { classes } = this.props;
    const { eventImages, eventSeatingChartImage, isVirtual, eventMap, status } = this.state;

    const windowWidth = window.innerWidth;
    const config = this.getConfig(isVirtual, windowWidth);

    const virtualText = status !== "Published" ? 'withVirtualText' : 'withoutVirtualText';
    const mapStatus = eventMap === "" ? 'withoutMap' : 'withMap';
    const seatingChartStatus = (eventSeatingChartImage === undefined || eventSeatingChartImage === "") ? 'withoutSeatingChart' : 'withSeatingChart';

    const imageBucket = this.getImageBucket(eventImages.length);

    const { small = {}, withoutImage, circleMargins = [] } = config;

    const source = eventImages.length > 0 ? small : withoutImage;

    const bucketConfig = this.getBucketConfig(source, eventImages.length);

    // Determine lineHeight based on map, seating chart status and image count
    const lineHeight =
        bucketConfig
            ?.[virtualText]
            ?.[mapStatus]
            ?.[seatingChartStatus] || "auto";

    const width = windowWidth;
    const imageCount = eventImages.length;

    function getAddressMargin(width) {
      if (width < 622) return "180px";
      if (width >= 1260 && width <= 1279) return "130px";
      if (width <= 1480) return "155px";
      return "130px";
    }

    function getVirtualTextMargin(width, status, isVirtual) {
      if (status === "Published") {
        return isVirtual ? "120px" : "130px";
      }

      if (!isVirtual) return "170px";

      if (width >= 779) return "160px";
      if (width >= 726) return "180px";
      if (width >= 696) return "160px";
      return "180px";
    }

    function getInvitationMargin(width) {
      if (width >= 1576) return "600px";
      if (width >= 1372) return "620px";
      if (width >= 1280) return "640px";
      if (width >= 1152) return "620px";
      if (width >= 769) return "640px";
      if (width >= 726) return "680px";
      if (width >= 675) return "640px";
      if (width >= 566) return "680px";
      if (width >= 526) return "700px";
      if (width >= 451) return "720px";
      return "720px";
    }

    // function getExtraMargin(width, imageCount) {
    //
    //   // ≥1030 → all same
    //   if (width >= 1030) {
    //     return "148px";
    //   }
    //
    //   // ≥981
    //   if (width >= 981) {
    //     if (imageCount >= 4) return "236px"; // 4,5
    //     return "148px"; // 0–3
    //   }
    //
    //   // ≥903
    //   if (width >= 903) {
    //     return "148px"; // all
    //   }
    //
    //   // ≥773
    //   if (width >= 773) {
    //     if (imageCount >= 4) return "236px"; // 4–5
    //     return "148px"; // 0-3
    //   }
    //
    //   // ≥726
    //   if (width >= 726) {
    //     if (imageCount >= 3) return "236px"; // 3–5
    //     return "148px"; // 0–2
    //   }
    //
    //   // ≥690
    //   if (width >= 690) {
    //     if (imageCount >= 4) return "236px"; // 4–5
    //     return "148px"; // 0–3
    //   }
    //
    //   // ≥560  ✅ your corrected case
    //   if (width >= 560) {
    //     if (imageCount >= 3) return "236px"; // 3–5
    //     return "145px"; // 0–2
    //   }
    //
    //   // ≥451 (3 groups)
    //   if (width >= 451) {
    //     if (imageCount >= 4) return "326px"; // 4–5
    //     if (imageCount >= 2) return "236px"; // 2–3
    //     return "148px"; // 0–1
    //   }
    //
    //   // <451
    //   return imageCount > 0 ? "248px" : "128px";
    // }

    const getExtraMargin = (width, imageCount) => {

      const bucket = this.getImageBucket(imageCount);

      if (width >= 1152) {
        return "148px";
      }

      if (width >= 1030) {
        return (bucket === "4" || bucket === "5") ? "236px" : "148px";
      }

      if (width >= 779) {
        return (bucket === "4" || bucket === "5") ? "236px" : "145px";
      }

      if (width >= 726) {
        return (bucket === "3" || bucket === "4" || bucket === "5") ? "236px" : "145px";
      }

      if (width >= 696) {
        return (bucket === "4" || bucket === "5") ? "236px" : "145px";
      }

      if (width >= 560) {
        return (bucket === "3" || bucket === "4" || bucket === "5") ? "236px" : "145px";
      }

      if (width >= 451) {
        if (bucket === "4" || bucket === "5") return "326px";
        if (bucket === "2" || bucket === "3") return "236px";
        return "148px";
      }

      return imageCount > 0 ? "248px" : "128px";
    }

    const extraMargins = {
      extraAddressMargin: getAddressMargin(width),
      extraVirtualTextMargin: getVirtualTextMargin(width, status, isVirtual),
      extraVirtualInvitationDetailsMargin: getInvitationMargin(width),
      extraMargin: getExtraMargin(width, imageCount),
      extraSeatingChartMargin: eventSeatingChartImage ? (width >= 451 && width <=458) ? "283px" : "248px" : "128px",
      extraPdfMargin: eventMap === "" ? "130px" : "179px"
    };

    // Calculate additional margins based on conditions
    // const extraMargins = {
    //   extraAddressMargin: (windowWidth >= 622) ? (windowWidth >= 1260) ? (windowWidth >= 1280) ? (windowWidth >= 1480) ? "135px" : "155px" : "135px" : "155px" : "180px",
    //   extraVirtualTextMargin: status !== "Published" ? (isVirtual ?  (windowWidth >= 696) ? (windowWidth >= 726) ? (windowWidth >= 779) ? "160px" : "180px" : "160px" : "180px" : "170px") : (isVirtual ? "120px" : "130px"),
    //   extraVirtualInvitationDetailsMargin: (windowWidth >= 451) ? (windowWidth >= 526) ? (windowWidth >= 566) ? (windowWidth >= 675) ? (windowWidth >= 726) ? (windowWidth >= 769) ? (windowWidth >= 1152) ? (windowWidth >= 1280) ? (windowWidth >= 1372) ? (windowWidth >= 1576) ? "600px" : "620px" : "640px" : "620px" : "640px" : "680px" : "640px" : "680px" : "700px" : "720px" : "720px",
    //   extraMargin:
    //       (windowWidth >= 1030 && (eventImages.length === 5 || eventImages.length === 4 || eventImages.length === 3 || eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //           ? "148px"
    //           : (windowWidth >= 981 && (eventImages.length === 3 || eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //               ? "148px"
    //               : (windowWidth >= 981 && (eventImages.length === 4 || eventImages.length === 5))
    //                   ? "236px"
    //                   : (windowWidth >= 903 && (eventImages.length === 5 || eventImages.length === 4 || eventImages.length === 3 || eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //                       ? "148px"
    //                       : (windowWidth >= 773 && (eventImages.length === 3 || eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //                           ? "148px"
    //                           : (windowWidth >= 690 && (eventImages.length === 4 || eventImages.length === 5))
    //                               ? "236px"
    //                               : (windowWidth >= 726 && (eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //                                   ? "148px"
    //                                   : (windowWidth >= 726 && (eventImages.length === 3 || eventImages.length === 4 || eventImages.length === 5))
    //                                       ? "236px"
    //                                       : (windowWidth >= 690 && (eventImages.length === 3 || eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //                                           ? "148px"
    //                                           : (windowWidth >= 690 && (eventImages.length === 4 || eventImages.length === 5))
    //                                               ? "236px"
    //                                               : (windowWidth >= 560 && (eventImages.length === 2 || eventImages.length === 1 || eventImages.length === 0))
    //                                                   ? "145px"
    //                                                   : (windowWidth >= 560 && (eventImages.length === 3 || eventImages.length === 4 || eventImages.length === 5))
    //                                                       ? "236px"
    //                                                       : (windowWidth >= 451 && (eventImages.length === 4 || eventImages.length === 5))
    //                                                           ? "326px"
    //                                                           : (windowWidth >= 451 && (eventImages.length === 3 || eventImages.length === 2))
    //                                                               ? "236px"
    //                                                               : (windowWidth >= 451 && (eventImages.length === 1 || eventImages.length === 0))
    //                                                                   ? "148px"
    //                                                                   : eventImages.length > 0
    //                                                                       ? "248px"
    //                                                                       : "128px",
    //   extraSeatingChartMargin: eventSeatingChartImage ? "248px" : "128px",
    //   extraPdfMargin: eventMap === "" ? "130px" : "179px"
    // };

    const updatedCircleMargins = [...circleMargins];
    updatedCircleMargins[1] = extraMargins.extraAddressMargin;
    updatedCircleMargins[2] = extraMargins.extraVirtualTextMargin;
    if (isVirtual) {
      updatedCircleMargins[3] = extraMargins.extraVirtualInvitationDetailsMargin;
      updatedCircleMargins[6] = extraMargins.extraMargin;
      updatedCircleMargins[7] = extraMargins.extraSeatingChartMargin;
      updatedCircleMargins[8] = extraMargins.extraPdfMargin;
    } else {
      updatedCircleMargins[5] = extraMargins.extraMargin;
      updatedCircleMargins[6] = extraMargins.extraSeatingChartMargin;
      updatedCircleMargins[7] = extraMargins.extraPdfMargin;
    }

    return (
        <React.Fragment>
      <span
          className={classes.lineHeightVerticalLineCalculator}
          style={{ height: lineHeight }}
      ></span>
          <div className={classes.eventDetailsAboutVerticalLineWithCirclesWrapper}>
            {updatedCircleMargins.map((margin, index) => (
                <div
                    key={index}
                    className={classes.eventDetailsAboutCircleOnVerticalLine}
                    style={{ margin: `0px 0px ${margin} -9px` }}
                ></div>
            ))}
          </div>
        </React.Fragment>
    );
  };

  getDate = (date) => {
    const dateObj = {
      year: parseInt(date.format("YYYY")),
      month: parseInt(date.format("MM")),
      day: parseInt(date.format("DD")),
    };
    return dateObj;
  };

  getGateFormat = (date) => {
    const dateObj = this.getDate(date);
    return `${dateObj.month}/${dateObj.day}/${dateObj.year}`;
  };

  textFieldLongInputWithTitle = (title, isDisabled = false, defaultValue = '') => {
    const { classes } = this.props;
    const formTitleMap = {
      "Event Title": "eventTitle",
      Location: "eventLocation",
      "Venue Name": "eventVenue",
    };
    return (
        <FormControl>
        <span className={classes.eventDetailsAboutInputLabel}>
          {this.titleWithToolTip(
              title,
              title === "Event Title"
                  ? "List the title of your event"
                  : "List the name of the venue your event will be taking place at",
              true
          )}
          <p
              style={this.createEventDetailsAboutErrorMessageLabelStyles(
                  formTitleMap[title]
              )}
          >{`Please enter ${title}`}</p>
        </span>
          <TextField
              required
              className={classes.eventDetailsAboutLongInputField}
              placeholder={isDisabled ? defaultValue : title}
              margin="normal"
              fullWidth
              value={isDisabled ? '' : this.state[formTitleMap[title]]}
              onChange={(e) => this.inputChange(formTitleMap[title], e)}
              InputProps={{
                disableUnderline: true,
                className: classes.eventDetailsAboutInputText,
                readOnly: isDisabled,
              }}
              onInput={(e) => {
                e.target.value =
                    title === "Event Title" || title === "Venue Name"
                        ? e.target.value.length > title === "Venue Name"
                            ? 40
                            : 75
                                ? e.target.value.slice(0, title === "Venue Name" ? 40 : 75)
                                : e.target.value
                        : e.target.value;
              }}
              helperText={
                title === "Event Title"
                    ? `${this.state[formTitleMap[title]].length}/75`
                    : title === "Venue Name" &&
                    `${isDisabled ? defaultValue.length : this.state[formTitleMap[title]].length}/40`
              }
              FormHelperTextProps={{
                className: classes.eventDetailsAboutInputHelperText,
              }}
          />
        </FormControl>
    );
  };

  textFieldTimeInput = (title) => {
    const { classes } = this.props;
    const {
      eventStartDate,
      eventStartTime,
      eventEndDate,
      eventEndTime,
      eventAboutUpdate,
    } = this.state;

    const isCloneEvent = localStorage.getItem("isCloneEvent");
    const date_picker_error =
        isCloneEvent === "true"
            ? title == "Start"
                ? moment(this.state.eventStartDate).format("MM-DD-YYYY") ===
                this.timeUTCtoLocal(
                    moment(),
                    this.props.eventAbout?.TimeZone
                ).format("MM-DD-YYYY")
                    ? "date_picker_error"
                    : ""
                : moment(this.state.eventEndDate).format("MM-DD-YYYY") ===
                this.timeUTCtoLocal(
                    moment(),
                    this.props.eventAbout?.TimeZone
                ).format("MM-DD-YYYY")
                    ? "date_picker_error"
                    : ""
            : "";

    return (
        <div
            style={{
              position: "relative",
            }}
        >
          <div className="date_time_pickers">
            <DatePicker
                value={
                  title == "Start"
                      ? this.getDate(eventStartDate)
                      : this.getDate(eventEndDate)
                }
                onChange={(date) => {
                  title == "Start"
                      ? this.ChangeStartDate(date)
                      : this.ChangeEndDate(date);
                  this.isValidEndDateTime(date, "Date", title);
                }}
                style={{ border: "1px solid #f00" }}
                inputClassName={`date_picker_input ${date_picker_error}`}
                colorPrimary="#851679" // added this
                minimumDate={
                  title == "Start"
                      ? this.getDate(moment())
                      : this.getDate(eventStartDate)
                }
                // maximumDate={this.getDate(maxEndDate)}
                inputPlaceholder="Select a day"
                formatInputText={(date) =>
                    title == "Start"
                        ? this.getGateFormat(eventStartDate)
                        : this.getGateFormat(eventEndDate)
                }
            />
            <TimePicker
                placeholder="Select Time"
                use12Hours
                showSecond={false}
                focusOnOpen={true}
                format="hh:mm A"
                value={title === "Start" ? eventStartTime : eventEndTime}
                onChange={(e) => {
                  title === "Start"
                      ? this.ChangeStartTime(e)
                      : this.ChangeEndTime(e);
                  this.isValidEndDateTime(e, "Time", title);
                }}
                className={`time_picker ${
                    date_picker_error === "date_picker_error"
                        ? "time_picker_input"
                        : ""
                } `}
                minuteStep={1}
                // disabledHours={() =>
                //   title === "Start"
                //     ? this.getDisabledHoursStart()
                //     : this.getDisabledHoursEnd()
                // }
                // disabledMinutes={() => this.getDisabledMinutes()}
            />
          </div>

          {title === "End" && this.state.isValidEndDateTime && (
              <div className="isValidEndDateTime">
                <p>End date can not be set before the start date of the event.</p>
              </div>
          )}
        </div>
    );
  };

  // getDisabledHoursStart = () => {
  //   let hours = [];

  //   const { eventStartDate } = this.state;

  //   const startDate = eventStartDate.format("DD/MM/YYYY");
  //   const today = moment().format("DD/MM/YYYY");

  //   if (startDate === today) {
  //     for (let i = 0; i < moment().hour(); i++) {
  //       hours.push(i);
  //     }
  //   }

  //   return hours;
  // };

  // getDisabledHoursEnd = () => {
  //   let hours = [];

  //   const { eventStartDate, eventEndDate, eventStartTime } = this.state;

  //   const startDate = eventStartDate.format("DD/MM/YYYY");
  //   const endDate = eventEndDate.format("DD/MM/YYYY");

  //   if (startDate === endDate) {
  //     for (let i = 0; i <= eventStartTime.hour() - 1; i++) {
  //       hours.push(i);
  //     }
  //   }

  //   return hours;
  // };

  // getDisabledMinutes = () => {
  //   let minutes = [];

  //   const { eventStartTime, eventStartDate, eventEndTime, eventEndDate } =
  //     this.state;

  //   const startDate = eventStartDate.format("DD/MM/YYYY");
  //   const endDate = eventEndDate.format("DD/MM/YYYY");

  //   if (startDate === endDate) {
  //     if (eventStartTime.hour() === eventEndTime.hour()) {
  //       for (var i = 0; i < eventStartTime.minute(); i++) {
  //         minutes.push(i);
  //       }
  //     }
  //   }

  //   return minutes;
  // };

  isValidEndDateTime = (input, type, title) => {
    const { eventStartTime, eventStartDate, eventEndTime, eventEndDate } =
        this.state;

    let eventDateStart = eventStartDate;
    let eventDateEnd = eventEndDate;
    if (type === "Date" && title === "Start") {
      eventDateStart = moment(
          `${input.year}-${input.month}-${input.day}`,
          "YYYY-MM-DD"
      );
    } else if (type === "Date" && title === "End") {
      eventDateEnd = moment(
          `${input.year}-${input.month}-${input.day}`,
          "YYYY-MM-DD"
      );
    }

    let eventTimeStart = eventStartTime;
    let eventTimeEnd = eventEndTime;
    if (type === "Time" && title === "Start") {
      eventTimeStart = moment(input);
      return this.setState({ isValidEndDateTime: false });
    } else if (type === "Time" && title === "End") {
      eventTimeEnd = moment(input);

    }

    const startDate = eventDateStart.format("DD/MM/YYYY");
    const endDate = eventDateEnd.format("DD/MM/YYYY");

    const startTime = eventTimeStart.format("HH:mm");
    const endTime = eventTimeEnd.format("HH:mm");

    const startDateTime = moment(
        `${startDate} ${startTime}`,
        "DD/MM/YYYY HH:mm"
    ).utcOffset("+00:00"); // Set the UTC offset
    const endDateTime = moment(
        `${endDate} ${endTime}`,
        "DD/MM/YYYY HH:mm"
    ).utcOffset("+00:00"); // Set the UTC offset

    const status = endDateTime.isBefore(startDateTime);
    const { isValidEndDateTime } = this.state;
    this.setState({ isValidEndDateTime: status });
  };

  getCompositeDateAndTime = (date, time) => {
    const { timezone } = this.state.eventAddress;
    const formattedDate = date.format("MM/DD/YYYY");
    const formattedTime = time.format("hh:mm:ss a");
    const dateAndTimeString = formattedDate + " " + formattedTime;
    const dateAndTime = moment(dateAndTimeString, "MM/DD/YYYY hh:mm:ss a");
    var dateTimeInUtc = momentTz
        .tz(dateAndTimeString, "MM/DD/YYYY hh:mm:ss a", timezone)
        .utc()
        .format();
    return dateTimeInUtc;
  };

  getCompositeDateAndTime2 = (date, time) => {
    const { timezone } = this.state.eventAddress;

    const formattedDate = date.format("MM/DD/YYYY");
    const formattedTime = time.format("hh:mm:ss a");

    const dateAndTimeString = formattedDate + " " + formattedTime;
    const dateAndTime = moment(dateAndTimeString, "MM/DD/YYYY hh:mm:ss a");
    var dateTimeInUtc = momentTz
        .tz(dateAndTimeString, "MM/DD/YYYY hh:mm:ss a", timezone)
        .utc()
        .format();

    return dateTimeInUtc;
  };

  convertToTimeZone = (date) => {
    const timeZone = "America/New_York";
    const timeZoneDate = moment.tz(date, timeZone);
    return timeZoneDate;
  };

  selectEventTypeDropdown = (title) => {
    const { classes } = this.props;
    const { categories } = this.state;
    return (
        <React.Fragment>
        <span className={classes.eventDetailsAboutInputLabel}>
          {this.titleWithToolTip(
              title,
              "Select which category best represents your event",
              true
          )}
        </span>
          <FormControl
              className={classes.eventDetailsAboutEventTypeDropdown}
              required={true}
              variant="outlined"
          >
            <NativeSelect
                fullWidth
                value={this.state.dropdownItem}
                onChange={this.handleDropdownChange}
                name="eventCategoryId"
                className={classes.nativeSelect}
            >
              {categories.map((c, i) => {
                return (
                    <option key={i} value={c.CategoryId}>
                      {c.CategoryName}
                    </option>
                );
              })}
            </NativeSelect>
          </FormControl>
        </React.Fragment>
    );
  };

  titleWithToolTip = (title, tipText, mandatory = false) => {
    const { classes } = this.props;
    const { About } = Events;
    return (
        <span className={classes.eventDetailsAboutInputLabel} style={{}}>
        {title}
          {mandatory && <span style={{ color: "red" }}> *</span>}
          {title === "Address" && (
              <span> - {About.addressExtraText}</span>
          )}
          <CreateEventDetailsAboutToolTip
              title={<React.Fragment>{tipText}</React.Fragment>}
          >
          <IconButton color={"primary"} style={{ padding: "0 0 0 10px" }}>
            <Info />
          </IconButton>
        </CreateEventDetailsAboutToolTip>
      </span>
    );
  };

  getFileBase64 = (file, callback) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    // Since FileReader is asynchronous,
    // we need to pass data back.
    reader.onload = () => callback(reader.result);
    // TODO: catch an error
    reader.onerror = (error) => {};
  };

  imageUploadCallback = (file) => {
    if (file) {
      if (file.size <= 2000000) {

        return new Promise((resolve, reject) => {
          this.getFileBase64(file, (dataUrl) => {
            const image = new Image();
            image.src = dataUrl;
            image.onload = () => {
              const canvas = document.createElement("canvas");
              const maxWidth = 800;
              const maxHeight = 800;
              let width = image.width;
              let height = image.height;

              if (width > height) {
                if (width > maxWidth) {
                  height *= maxWidth / width;
                  width = maxWidth;
                }
              } else {
                if (height > maxHeight) {
                  width *= maxHeight / height;
                  height = maxHeight;
                }
              }

              canvas.width = width;
              canvas.height = height;

              const ctx = canvas.getContext("2d");
              ctx.drawImage(image, 0, 0, width, height);

              canvas.toBlob(
                  (blob) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                      resolve({ data: { link: reader.result } });
                    };
                    reader.readAsDataURL(blob);
                  },
                  "image/jpeg",
                  0.7
              );
            };
          });
        });

        // return new Promise((resolve, reject) =>
        //     this.getFileBase64(file, (data) => resolve({data: {link: data}}))
        // );
      } else {
        this.setState({
          error: { show: true, message: ErrorMessages.imageSize2MB },
        });
      }
    }
  };

  largeTextField = (title, editorState, onEditorStateChange, type) => {
    const { classes } = this.props;
    const mandatoryOrNot = title === "Parking" ? false : true;
    const styleMap = {
      STRIKETHROUGH: {
        textDecoration: "line-through",
      },
      textAlign: "center",
    };
    return (
        <React.Fragment>
          {this.titleWithToolTip(
              title,
              title === "Parking"
                  ? "Describe parking and/or upload relevant parking images/maps"
                  : "Describe your event",
              mandatoryOrNot
          )}
          {/* <Grammarly > */}
          <GrammarlyEditorPlugin clientId="client_FdjdCy5cG4i2Wxi74peEG2">
            <Editor
                editorStyle={{ textAlign: "center" }}
                editorState={editorState}
                customStyleMap={styleMap}
                editorClassName="editor-class-about"
                toolbarClassName="toolbar-class-about"
                wrapperClassName="wrapper-class-about"
                onEditorStateChange={onEditorStateChange}
                toolbar={{
                  image: {
                    previewImage: true,
                    urlEnabled: true,
                    uploadEnabled: true,
                    // alt: { present: true, mandatory: true },
                    uploadCallback: (file) => this.imageUploadCallback(file),
                    inputAccept:
                        "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                    defaultSize: {
                      height: "auto",
                      width: "100%",
                    },
                  },
                }}
                handlePastedText={() => this.imageUploadCallback()}
                //    handleReturn={(event) => {
                //     // override behavior for enter key
                //     var newEditorState = null;
                //     if (event.keyCode === 13 && event.shiftKey) {
                //         // with shift, make a new block
                //         newEditorState = insertNewUnstyledBlock(editorState);
                //     } else if (event.keyCode === 13 && !event.shiftKey) {
                //         // without shift, just a normal line break
                //         newEditorState = RichUtils.insertSoftNewline(editorState);
                //     }
                //     if (newEditorState) {
                //       if(type === 1){
                //        this.setState({editorState: newEditorState})
                //         return true;
                //       }else{
                //         this.setState({editorState2: newEditorState})
                //         return true;
                //       }

                //     }
                //     return false;
                // }}
            />
          </GrammarlyEditorPlugin>
          {/* </Grammarly> */}
        </React.Fragment>
    );
  };

  virtualEventDescriptionTextField = (title, editorState, onEditorStateChange) => {
    const { classes } = this.props;

    const styleMap = {
      STRIKETHROUGH: {
        textDecoration: "line-through",
      },
      textAlign: "center",
    };
    return (
        <React.Fragment>
          {this.titleWithToolTip(
              title,
              "Describe your event",
              true
          )}
          <div style={{marginTop:"10px", marginBottom:"10px"}}>
            <span>
              - Use this space to add your streaming provider's meeting link + password. Your ticket holders will receive this link after they register and in reminder emails.
            </span>
            <br/>
            <span>
              - Please use the 'Address' field above to add your city/state so attendees in that area can find this event on the UBMe Map!
            </span>
            <br/>
            <span>
              - Once you publish an online event, you <span style={{fontWeight:"600"}}>CANNOT</span> change it to a physical event.
            </span>
          </div>
          {/* <Grammarly > */}
          <GrammarlyEditorPlugin clientId="client_FdjdCy5cG4i2Wxi74peEG2">
            <Editor
                editorStyle={{ textAlign: "center" }}
                editorState={editorState}
                customStyleMap={styleMap}
                editorClassName="editor-class-about"
                toolbarClassName="toolbar-class-about"
                wrapperClassName="wrapper-class-about"
                onEditorStateChange={onEditorStateChange}
                toolbar={{
                  image: {
                    previewImage: true,
                    urlEnabled: true,
                    uploadEnabled: true,
                    // alt: { present: true, mandatory: true },
                    uploadCallback: (file) => this.imageUploadCallback(file),
                    inputAccept:
                        "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                    defaultSize: {
                      height: "auto",
                      width: "100%",
                    },
                  },
                }}
                handlePastedText={() => this.imageUploadCallback()}
                //    handleReturn={(event) => {
                //     // override behavior for enter key
                //     var newEditorState = null;
                //     if (event.keyCode === 13 && event.shiftKey) {
                //         // with shift, make a new block
                //         newEditorState = insertNewUnstyledBlock(editorState);
                //     } else if (event.keyCode === 13 && !event.shiftKey) {
                //         // without shift, just a normal line break
                //         newEditorState = RichUtils.insertSoftNewline(editorState);
                //     }
                //     if (newEditorState) {
                //       if(type === 1){
                //        this.setState({editorState: newEditorState})
                //         return true;
                //       }else{
                //         this.setState({editorState2: newEditorState})
                //         return true;
                //       }

                //     }
                //     return false;
                // }}
            />
          </GrammarlyEditorPlugin>
          {/* </Grammarly> */}
        </React.Fragment>
    );
  };

  loaderState = (show) => {
    this.setState({ loader: show });
  };

  saveEvent = async () => {
    const eventImagesExist = this.state.eventImages.length > 0 ? "exists" : "";

    // Open Loader
    this.loaderState(true);

    const mandatoryFields = [
      this.state.eventTitle,
      this.state.eventLocation,
      this.state.isVirtual ? 'Online Event' : this.state.eventVenue,
      this.state.eventStartDate,
      this.state.eventEndDate,
      this.state.eventStartTime,
      this.state.eventEndTime,
      this.state.dropdownItem,
      this.state.editorHtml1,
      this.state.eventImages.length,
      eventImagesExist,
    ];

    if (this.state.isVirtual) {
      mandatoryFields.push(this.state.virtualEventDescriptionHtml); // Add all virtual-specific fields here
    }

    this.props.currentEventStatus(true);

    if (mandatoryFields.some((val) => val === "")) {
      this.setState({
        saveClickedForErrorMessages: true,
      });
      window.scrollTo({ top: 0 });
    } else {
      this.setState({
        submitButtonDisabled: true,
      });
      this.state.eventAboutUpdate
          ? this.updateEventAboutRemote()
          : this.addEventAboutRemote();
    }
  };

  replcaeEmptyTagwithBreak = (html) => {
    const newHtml = html
        ?.replaceAll("<p></p>", "<h6></h6>")
        .replaceAll("<h1></h1>", "<h6></h6>")
        .replaceAll("<h2></h2>", "<h6></h4>")
        .replaceAll("<h3></h3>", "<h6></h6>")
        .replaceAll("<h4></h4>", "<h6></h6>")
        .replaceAll("<h5></h5>", "<h6></h6>")
        .replaceAll("<h6></h6>", "<h6></h6>")
        .replaceAll("<pre></pre>", "<h6></h6>")
        .replaceAll("<blockquote></blockquote>", "<h6></h6>");

    return newHtml;
  };

  // Helper to determine if a value is base64 or a URL
  isBase64 = (str) => str && str.includes(",") && str.includes("base64");

// Helper to extract the right value to send
  getImageValue = (imgField) => {
    if (!imgField) return "";
    if (this.isBase64(imgField)) {
      // New upload — strip the data URI prefix, send raw base64
      return imgField.split(",")[1];
    }
    // Already a server URL — send as-is so backend extracts filename
    return imgField;
  };

  addEventAboutRemote = async () => {
    const {
      eventTitle,
      eventVenue,
      eventLocation,
      eventAddress,
      eventStartDate,
      eventEndDate,
      eventMap,
      eventSeatingChartImage,
      eventDescription,
      eventParking,
      saveClickedForErrorMessages,
      eventImages,
      eventStartTime,
      eventEndTime,
      dropdownItem,
      editorHtml1,
      editorHtml2,
      virtualEventDescriptionHtml,
      isVirtual,
      hideEndDateTime,
    } = this.state;

    const payload = {
      UserId: localStorage.getItem("UserId"),
      Title: eventTitle,
      Description: this.replcaeEmptyTagwithBreak(editorHtml1),
      VenueName: isVirtual ? 'Online Event' : eventVenue,
      Add1: eventAddress.name,
      City: eventAddress.city || "",
      Region: eventAddress.state || "",
      Country: eventAddress.country || "",
      TimeZone: eventAddress.timezone,
      Latitude: eventAddress.lat,
      Longitude: eventAddress.lng,
      IsVirtual: isVirtual ? '1' : '0',
      VirtualEventDetails: this.replcaeEmptyTagwithBreak(virtualEventDescriptionHtml) || "",
      StartDateTime: this.getCompositeDateAndTime(eventStartDate, eventStartTime),
      EndDateTime: this.getCompositeDateAndTime(eventEndDate, eventEndTime),
      Images: JSON.stringify(eventImages.map(img => ({
        SmallImage:  this.getImageValue(img.small),
        MediumImage: this.getImageValue(img.medium),
        LargeImage:  this.getImageValue(img.large),
      }))),
      SmallImage:  this.getImageValue(eventImages[0]?.small),
      MediumImage: this.getImageValue(eventImages[0]?.medium),
      LargeImage:  this.getImageValue(eventImages[0]?.large),
      EventType: this.state.dropdownItem,
      Parking: this.replcaeEmptyTagwithBreak(editorHtml2) || "",
      EventMap: eventMap.split(",")[1] || "",
      SeatingChartImage: eventSeatingChartImage.split(",")[1] || "",
      Status: "Draft",
      Add2: eventAddress.addr || "",
      PostalCode: eventAddress.postalCode || "",
      HideEndDateTime: hideEndDateTime ? '1' : '0',
    };

    // ── Print payload for Postman debugging ──
    console.log("=== ADD EVENT PAYLOAD ===");
    console.log(JSON.stringify(payload, null, 2));
    console.log("========================");

    // Also log a Postman-ready version with truncated image strings
    // (full base64 is too long to read — this shows just the first 50 chars)
    const postmanDebug = {
      ...payload,
      SmallImage:  payload.SmallImage?.substring(0, 50)  + "...[base64]",
      MediumImage: payload.MediumImage?.substring(0, 50) + "...[base64]",
      LargeImage:  payload.LargeImage?.substring(0, 50)  + "...[base64]",
      Images: "[see full Images array below]",
    };
    console.log("=== POSTMAN DEBUG (truncated images) ===");
    console.log(JSON.stringify(postmanDebug, null, 2));

    const response = await this.props
        .addUpdateEventByEventUser(payload)
        .then((val) => {
          localStorage.removeItem("isCloneEvent");
          localStorage.setItem("CurrentEventId", JSON.stringify(JSON.parse(val.data.results.Data).EventId));

          if (val && val.status >= 200 && val.status <= 300) {
            this.GetEventFeeData(JSON.parse(val.data.results.Data).EventId);

            this.props.updateDescriptor({
              EventId: JSON.parse(val.data.results.Data).EventId,
              PaymentDescriptor: JSON.parse(val.data.results.Data)
                  .PaymentDescriptor,
            });

            localStorage.setItem("isItCreateOrEditEvent", "Edit");
            history.push("FAQ");
          } else {
            this.setState({
              error: { show: true, message: ErrorMessages.somethingWentWrong },
              submitButtonDisabled: false,
            });
          }
        })
        .catch((err) => {
          // console.log(err);
          this.setState({
            error: { show: true, message: err.message },
            submitButtonDisabled: false,
          });
        })
        .finally(() => this.loaderState(false));
  };

  checkDateTimeChange = (date, time, StartDateTime, TimeZone) => {
    const formattedDate = date.format("MM/DD/YYYY");
    const formattedTime = time.format("hh:mm:ss a");
    const dateAndTimeString = formattedDate + " " + formattedTime;
    var local = momentTz
        .tz(moment.utc(StartDateTime), "MM/DD/YYYY hh:mm:ss a", TimeZone)
        .format("MM/DD/YYYY hh:mm:ss a");
    const dateString = moment(local, "MM/DD/YYYY hh:mm:ss a");
    return (
        moment(dateString).format("MM/DD/YYYY hh:mm:ss a") === dateAndTimeString
    );
  };

  processImage = (img) => {
    if (!img) return "";

    // Base64 image
    if (img.includes("base64") || img.includes("data:image")) {
      return img.split(",")[1];
    }

    // CloudFront URL
    if (img.startsWith("http")) {
      return img; // or extract filename if backend requires
    }

    return img;
  };

  updateEventAboutRemote = async () => {
    try {
      const {
        eventTitle,
        eventVenue,
        eventAddress = {},
        eventStartDate,
        eventEndDate,
        eventMap,
        eventSeatingChartImage,
        eventImages = [],
        eventStartTime,
        eventEndTime,
        dropdownItem,
        editorHtml1,
        editorHtml2,
        virtualEventDescriptionHtml,
        isVirtual,
        hideEndDateTime,
      } = this.state;

      const payload = {
        EventId: this.props.eventId,
        UserId: localStorage.getItem("UserId"),
        Title: eventTitle,
        Description: this.replcaeEmptyTagwithBreak(editorHtml1),
        VenueName: isVirtual ? "Online Event" : eventVenue,

        Add1: eventAddress?.name || "",
        City: eventAddress?.city || "",
        Region: eventAddress?.state || "",
        Country: eventAddress?.country || "",
        TimeZone: eventAddress?.timezone || "",
        Latitude: eventAddress?.lat || "",
        Longitude: eventAddress?.lng || "",

        IsVirtual: isVirtual ? "1" : "0",
        VirtualEventDetails:
            this.replcaeEmptyTagwithBreak(virtualEventDescriptionHtml) || "",

        StartDateTime: this.getCompositeDateAndTime(eventStartDate, eventStartTime),
        EndDateTime: this.getCompositeDateAndTime(eventEndDate, eventEndTime),

        SmallImage: eventImages?.[0]?.small?.split(",")?.[1] || "",
        MediumImage: eventImages?.[0]?.medium?.split(",")?.[1] || "",
        LargeImage: eventImages?.[0]?.large?.split(",")?.[1] || "",

        Images: JSON.stringify(
            eventImages.map(img => ({
              SmallImage: this.processImage(img.small),
              MediumImage: this.processImage(img.medium),
              LargeImage: this.processImage(img.large),
            }))
        ),

        EventType: dropdownItem,
        Parking: this.replcaeEmptyTagwithBreak(editorHtml2) || "",
        EventMap: eventMap?.split(",")?.[1] || "",
        SeatingChartImage: eventSeatingChartImage?.split(",")?.[1] || "",
        Status: "Draft",
        Add2: eventAddress?.addr || "",
        PostalCode: eventAddress?.postalCode || "",
        HideEndDateTime: hideEndDateTime ? "1" : "0",
      };

      console.log("=== UPDATE EVENT PAYLOAD ===", payload);

      const val = await this.props.updateEventByEventUser(payload);

      const data = JSON.parse(val?.data?.results?.Data || "{}");

      localStorage.removeItem("isCloneEvent");

      if (val?.status >= 200 && val?.status <= 300) {
        this.GetEventFeeData(data.EventId);

        localStorage.setItem("PaymentDescriptor", data.PaymentDescriptor);
        localStorage.setItem("isItCreateOrEditEvent", "Edit");

        history.push("FAQ");
      } else {
        this.setState({
          error: { show: true, message: ErrorMessages.somethingWentWrong },
          submitButtonDisabled: false,
        });
      }
    } catch (err) {
      this.setState({
        error: { show: true, message: err.message },
        submitButtonDisabled: false,
      });
    } finally {
      this.loaderState(false);
    }
  };

    progressLoader = () => {
      const { loader } = this.state;

      return loader && <Loader />;
    };

    handleError = () => {
      this.setState({ error: { show: false, message: "" } });
    };

    // check if its a pdf url or not
    isPdf = (url) => {
      return url.match(/\.(pdf)$/i);
    };

    openPDf = (pdfString) => {
      if (this.isPdf(pdfString)) {
        window.open(pdfString, "_blank");
      } else {
        this.b6ç4toUrl(pdfString).then((val) => {
          window.open(val, "_blank");
        });
      }
    };

    b6ç4toUrl = async (base64Data) => {
      const r = await fetch(base64Data);
      const blob = await r.blob();
      return URL.createObjectURL(blob);
    };

    render() {
      const { eventStartDate, eventStartTime, editorHtml2 } = this.state;
      const { eventAbout } = this.props;
      const { classes } = this.props;
      const eventImagesExist =
          Object.keys(this.state.eventImages).length > 0 ? "exists" : "";
      const pageTitle = "About";
      const isCloneEvent = localStorage.getItem("isCloneEvent");
      const mandatoryFields = [
        this.state.eventTitle,
        this.state.eventAddress.toString(),
        this.state.isVirtual ? 'Online Event' : this.state.eventVenue,
        this.state.dropdownItem.toString(),
        this.state.editorState.getCurrentContent().getPlainText("\u0001"),
        eventImagesExist,
      ];
      const { About } = Events;

      if (this.state.isVirtual) {
        mandatoryFields.push(this.state.virtualEventDescription.getCurrentContent().getPlainText("\u0001")); // Add all virtual-specific fields here
      }

      const scheduleEmailDeleteModal = () => {
        return (
            <Modal
                open={this.state.clonealert}
                onClose={() => this.setState({ clonealert: false })}
            >
              <div className={classes.eventDetailsAboutCloneEventPopup}>
                <div
                    style={{
                      textAlign: "center",
                      height: "100px",
                      marginTop: "18px"
                    }}
                >
                  <p style={{fontSize: 18}}><strong>{Text.CongratulationsOnEventClone}</strong></p>
                </div>
                <p style={{ textAlign: "center", fontSize: 16 }}>
                  {Text.PleaseCheckStartAndEndDateInAboutAndCreateTicket}
                </p>
                <p style={{ textAlign: "center", fontSize: 16 }}>
                  {Text.PleaseReapplyTicketTypesInCouponOrCustomQuestion}
                </p>
                <div style={{textAlign: "center"}}>
                  <Button
                      // className={classes.deleteModalSaveAndCancelButton}
                      onClick={() => this.setState({ clonealert: false })}
                      style={{
                        color: "red",
                        fontSize: "1.5rem",
                        padding: "10px 25px",
                        textAlign: "center",
                      }}
                  >
                    {Text.Understood}
                  </Button>
                </div>
              </div>
            </Modal>
        );
      };

      return (
          <React.Fragment>
            {scheduleEmailDeleteModal()}
            <ContentGrid
                content={
                  <Grid
                      className={`${classes.eventDetailsAboutGrid} relative-wrapper-component `}
                  >
                    <section className={classes.eventDetailsAboutMainWrapper}>
                      <EventHeader title={pageTitle} />
                      <div
                          className={classes.eventDetailsAboutWrapper}
                          style={{ pointerEvents: this.state.loader ? "none" : "auto" }}
                      >
                        {this.verticalLineWithCircles()}

                        <div className={classes.eventDetailsAboutFormWrapper}>
                          <Grid
                              className={
                                classes.eventDetailsAboutNameLocationVenueGridWrapper
                              }
                          >
                            {this.textFieldLongInputWithTitle(About.title)}
                            {this.textFieldSuggestionInputWithTitle(About.address)}
                            {this.state.isVirtual
                                ?
                                this.textFieldLongInputWithTitle(About.venue, true, 'Online Event')
                                :
                                this.textFieldLongInputWithTitle(About.venue)
                            }
                            {this.state.status !== "Published" &&
                                <span style={{ marginBottom: "20px", color: "#a338a4" }}>
                                            Is this a virtual event?{" "}
                                  <span
                                      style={{ color: "#a338a4", cursor: "pointer", textDecoration: 'underline' }}
                                      onClick={this.toggleVirtual}
                                  >
                              {this.state.isVirtual
                                  ? "Oops, my event is in person - click here to hide virtual details"
                                  : "Click Here"}
                            </span>
                          </span>
                            }
                            {this.state.isVirtual && (
                                <>
                                  {this.virtualEventDescriptionTextField(
                                      About.virtualInvitationDetails,
                                      this.state.virtualEventDescription,
                                      this.onVirtualEventStateChange,
                                  )}
                                </>
                            )}
                          </Grid>

                          <Grid
                              container
                              spacing={2}
                              className={
                                classes.eventDetailsAboutStartEndDateGridWrapper
                              }
                          >
                            <Grid item xs={12} sm={8} md={6}>
                        <span
                            className={
                              classes.eventDetailsAboutStartTimeInputLabel
                            }
                        >
                          {this.titleWithToolTip(
                              "Start",
                              "Fill in the start date and time of your event",
                              true
                          )}
                        </span>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={8} md={6}>
                              {this.textFieldTimeInput(
                                  "Start",
                                  "Fill in the start date and time of your event"
                              )}
                            </Grid>
                          </Grid>

                          <Grid
                              container
                              spacing={2}
                              className={
                                classes.eventDetailsAboutStartEndDateGridWrapper
                              }
                          >
                            <Grid item xs={12} sm={8} md={6}>
                        <span
                            className={classes.eventDetailsAboutEndTimeInputLabel}
                        >
                          {this.titleWithToolTip(
                              "End",
                              "Fill in the end date and time of your event",
                              true
                          )}
                        </span>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={8} md={6}>
                              {this.textFieldTimeInput(
                                  "End",
                                  "Fill in the end date and time of your event"
                              )}
                            </Grid>
                          </Grid>
                          <Grid>
                            <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: 20,
                                  position: "relative",
                                  left: "-10px",
                                  marginLeft: "30px",
                                  marginTop: "-30px"
                                }}
                            >
                              <Checkbox
                                  id="topping"
                                  name="topping"
                                  checked={this.state.hideEndDateTime}
                                  onChange={this.toggleHideEndDateTime}
                                  // sx={{
                                  //   color: red[500],
                                  // }}
                              />
                              <div>
                                <p>
                                  Hide end time
                                </p>
                              </div>
                            </div>
                          </Grid>
                          <Grid className={classes.eventDetailsAboutLowerGridWrapper}>
                            {this.titleWithToolTip(
                                About.image,
                                "Upload a photo for your event’s landing page header",
                                true
                            )}
                            {/*<div*/}
                            {/*    style={{*/}
                            {/*      position: "relative",*/}
                            {/*      display: this.state.eventImages.small*/}
                            {/*          ? "block"*/}
                            {/*          : "none",*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*  <img*/}
                            {/*      src={this.state.eventImages.small}*/}
                            {/*      style={{*/}
                            {/*        width: "240px",*/}
                            {/*        height: "120px",*/}
                            {/*      }}*/}
                            {/*  />*/}
                            {/*</div>*/}
                            {/*<input*/}
                            {/*    style={{ display: "none" }}*/}
                            {/*    id="eventDetailsAboutImage"*/}
                            {/*    multiple={true}*/}
                            {/*    type="file"*/}
                            {/*    onClick={(e) => {*/}
                            {/*      e.target.value = null;*/}
                            {/*    }}*/}
                            {/*    onChange={(e) => this.uploadPicture(e, "image")}*/}
                            {/*    accept=".png,.jpg,.jpeg"*/}
                            {/*/>*/}
                            {/*<label*/}
                            {/*    htmlFor="eventDetailsAboutImage"*/}
                            {/*    style={{*/}
                            {/*      width: "150px",*/}
                            {/*      height: "45px",*/}
                            {/*      marginBottom: "55px",*/}
                            {/*      marginTop: "20px",*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*  <Button*/}
                            {/*      className={classes.eventDetailsAboutUploadMap}*/}
                            {/*      color={"primary"}*/}
                            {/*      variant={"contained"}*/}
                            {/*      component="span"*/}
                            {/*  >*/}
                            {/*    {Text.UploadImage}*/}
                            {/*  </Button>*/}
                            {/*</label>*/}



                            {/* Multi-image upload grid */}
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", marginTop: "10px", marginBottom: "48px" }}>

                              {/* Uploaded image thumbnails */}
                              {this.state.eventImages.map((img, index) => (
                                  <div
                                      key={index}
                                      draggable
                                      onDragStart={() => this.setState({ draggedImageIndex: index })}
                                      onDragOver={(e) => e.preventDefault()}
                                      onDrop={() => this.swapImages(index)}
                                      onMouseEnter={() => this.setState({ hoveredImageIndex: index })}
                                      onMouseLeave={() => this.setState({ hoveredImageIndex: null })}
                                      style={{
                                        position: "relative",
                                        width: "120px",
                                        height: "80px",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        border: index === 0 ? "2px solid #a338a4" : "",
                                        flexShrink: 0,
                                        cursor: this.state.hoveredImageIndex === index ? "grab" : "default",
                                      }}
                                  >
                                    <img
                                        src={img.small || img.preview}
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />

                                    {/* Featured star — only on first image */}
                                    {index === 0 && (
                                        <div
                                            style={{
                                              position: "absolute",
                                              top: "3px",
                                              left: "5px",
                                              background: "#a338a4",
                                              color: "#fff",
                                              fontSize: "9px",
                                              fontWeight: "bold",
                                              padding: "1px 5px",
                                              borderRadius: "4px",
                                              lineHeight: "16px",
                                            }}
                                        >
                                          ★ Featured
                                        </div>
                                    )}

                                    {/* Drag icon — only on hover */}
                                    {this.state.hoveredImageIndex === index && (
                                        <div
                                            style={{
                                              position: "absolute",
                                              bottom: "4px",
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                              background: "rgba(0,0,0,0.5)",
                                              borderRadius: "4px",
                                              padding: "2px 5px",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "2px",
                                              pointerEvents: "none",
                                            }}
                                        >
                                          {/* Drag dots icon */}
                                          {[0, 1, 2].map((col) => (
                                              <div key={col} style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                                {[0, 1].map((row) => (
                                                    <div
                                                        key={row}
                                                        style={{
                                                          width: "3px",
                                                          height: "3px",
                                                          borderRadius: "50%",
                                                          background: "#fff",
                                                        }}
                                                    />
                                                ))}
                                              </div>
                                          ))}
                                        </div>
                                    )}

                                    {/* Remove button */}
                                    <button
                                        style={{
                                          position: "absolute",
                                          top: "2px",
                                          right: "4px",
                                          background: "rgba(0,0,0,0.5)",
                                          color: "#fff",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "18px",
                                          height: "18px",
                                          cursor: "pointer",
                                          fontSize: "11px",
                                          lineHeight: "18px",
                                          padding: 0,
                                          textAlign: "center",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.removeImage(index);
                                        }}
                                    >
                                      ✕
                                    </button>
                                  </div>
                              ))}

                              {/* Add button — hidden when 5 images reached */}
                              {this.state.eventImages.length < 5 && (
                                  <div
                                      onClick={() => document.getElementById("eventDetailsAboutImage").click()}
                                      style={{
                                        width: "120px",
                                        height: "80px",
                                        borderRadius: "10px",
                                        border: "1.5px dashed #ccc",
                                        backgroundColor: "#f5f5f5",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        flexShrink: 0,
                                      }}
                                  >
                                    <span style={{ fontSize: "28px", color: "#a338a4", lineHeight: 1 }}>+</span>
                                    <span style={{ fontSize: "11px", color: "#999", marginTop: "4px" }}>
                                    {this.state.eventImages.length}/5
                                  </span>
                                  </div>
                              )}

                            </div>

                            {/* Hidden file input */}
                            <input
                                style={{ display: "none" }}
                                id="eventDetailsAboutImage"
                                multiple={true}
                                type="file"
                                onClick={(e) => { e.target.value = null; }}
                                onChange={(e) => this.uploadPicture(e, "image")}
                                accept=".png,.jpg,.jpeg"
                            />







                            {this.titleWithToolTip(
                                About.seatingChartImage,
                                "Upload your event seating chart here for your attendees to view during checkout (optional).",
                                false
                            )}

                            <div
                                style={{
                                  position: "relative",
                                  display: this.state.eventSeatingChartImage
                                      ? "block"
                                      : "none",
                                }}
                            >
                              <img
                                  src={this.state.eventSeatingChartImage}
                                  style={{
                                    width: "240px",
                                    height: "120px",
                                  }}
                              />
                              {/* Render Remove button if image is uploaded */}
                              {this.state.eventSeatingChartImage && (
                                  <Button
                                      style={{ marginTop: "10px", marginLeft: "10px" }}
                                      color="secondary"
                                      variant="outlined"
                                      onClick={() => this.removeSeatingChart()}
                                  >
                                    Remove
                                  </Button>
                              )}
                            </div>
                            <input
                                style={{ display: "none" }}
                                id="eventDetailsAboutSeatingChartImage"
                                multiple={true}
                                type="file"
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                                onChange={(e) => this.uploadSeatingChartPicture(e)}
                                accept=".png,.jpg,.jpeg"
                            />
                            <label
                                htmlFor="eventDetailsAboutSeatingChartImage"
                                style={{
                                  width: "150px",
                                  height: "45px",
                                  marginBottom: "55px",
                                  marginTop: "20px",
                                }}
                            >
                              <Button
                                  className={classes.eventDetailsAboutSeatingChartUpload}
                                  color={"primary"}
                                  variant={"contained"}
                                  component="span"
                              >
                                {Text.UploadSeatingChart}
                              </Button>
                            </label>

                            {this.titleWithToolTip(
                                About.pdf,
                                "Upload a PDF of your event’s map (if required)",
                                false
                            )}

                            <div
                                style={{
                                  position: "relative",
                                  marginTop: "10px",
                                  fontStyle: "normal",
                                  display: this.state.eventMap ? "flex" : "none",
                                  alignItems: "center",
                                }}
                            >
                              <a onClick={(e) => this.openPDf(this.state.eventMap)}>
                                {Text.ViewMap}
                              </a>
                              <IconButton
                                  color={"primary"}
                                  variant="outlined"
                                  onClick={() => this.removeEventMap()}
                                  style={{
                                    marginLeft: "25px",
                                  }}
                              >
                                <ClearIcon />
                              </IconButton>
                            </div>
                            <input
                                style={{ display: "none" }}
                                id="eventDetailsAboutEventMap"
                                multiple={true}
                                type="file"
                                onChange={(e) => this.uploadPDF(e)}
                                accept=".pdf,.doc"
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                            />
                            <label
                                htmlFor="eventDetailsAboutEventMap"
                                style={{
                                  width: "150px",
                                  height: "0px",
                                  marginBottom: "102px",
                                  marginTop: "20px",
                                }}
                            >
                              <Button
                                  className={classes.eventDetailsAboutUploadMap}
                                  color={"primary"}
                                  variant={"contained"}
                                  component="span"
                              >
                                {Text.UploadMap}
                              </Button>
                            </label>
                            {this.selectEventTypeDropdown(About.type)}
                            {/* <span className={classes.eventDetailsAboutInputLabel}>
                       {this.titleWithToolTip("Event Description", false)}
                       </span> */}
                            {/* <textarea style={{height:300, width:"100%", resize: "none",
                        padding: 10,
                        whiteSpace:'pre-line',
                        margin:"10px 0px 20px 0px",
                        border: '1px solid #ced4da',
                        outline:'none',
                        overflowWrap: "break-word",}} />  */}
                            {this.largeTextField(
                                About.description,
                                this.state.editorState,
                                this.onEditorStateChange,
                                1
                            )}

                            {this.largeTextField(
                                About.parking,
                                this.state.editorState2,
                                this.onEditorStateChange1,
                                2
                            )}
                            {/* <span className={classes.eventDetailsAboutInputLabel}>
                       {this.titleWithToolTip("Parking", false)}
                       </span> */}
                            {/* <textarea style={{height:300, width:"100%", resize: "none",
                        padding: 10,
                        whiteSpace:'pre-line',
                        margin:"10px 0px 20px 0px",
                        border: '1px solid #ced4da',
                        outline:'none',
                        overflowWrap: "break-word",}} />  */}
                          </Grid>
                        </div>
                      </div>
                      <div className={classes.eventDetailsAboutButtonWrapper}>
                        <Button
                            className={classes.eventDetailsAboutMakeYourEventLiveButton}
                            variant={"contained"}
                            onClick={() => this.saveEvent()}
                            disabled={
                                mandatoryFields.some(
                                    (val) => val === "" || val.trim().length === 0
                                ) ||
                                this.state.submitButtonDisabled ||
                                this.state.isValidEndDateTime
                            }
                            sx={{
                              "&.Mui-disabled": {
                                background: "#eae",
                                color: "#c0c0c0",
                              },
                            }}
                        >
                          {Text.SaveAndContinue}
                        </Button>
                        <Modal
                            open={this.state.eventImageCropperModal}
                            onClose={() => this.handleCropImageModal(false)}
                        >
                          <div className={classes.eventImageCropperModal}>
                            <ImageCropper
                                imgSrc={this.state.eventImageToCrop}
                                setImage={this.setMultipleResizedImages}
                                cropModal={this.handleCropImageModal}
                            />
                          </div>
                        </Modal>
                        {this.progressLoader()}
                        <CreateEventErrorMessage
                            state={this.state.error}
                            close={this.handleError}
                        />
                      </div>
                    </section>
                  </Grid>
                }
            />
            <h1
                style={this.createEventDetailsAboutEventCreatedSuccessMessageStyles()}
            >
              {Text.EventSaved}
            </h1>
          </React.Fragment>
      );
    }
  }

  const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
      {
        addUpdateEventByEventUser,
        updateEventByEventUser,
        currentEventStatus,
        editEvenntByEventUser,
        updateDescriptor,
      },
      dispatch
  );
};

  const mapStateToProps = (state) => {
  return {
    eventAbout: state.eventUserEvents.eventsAbout,
    eventId: state.eventUserEvents.eventId,
    eventDetails: state.eventUserEvents,
  };
};

  export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withStyles(styles)(EventDetailsAbout));
